/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SplatRouteImport } from './routes/$splat'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedGeneralRouteRouteImport } from './routes/_authenticated/_general/route'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsUsersRouteRouteImport } from './routes/_authenticated/settings/users/route'
import { Route as AuthenticatedSettingsSalesChannelsRouteRouteImport } from './routes/_authenticated/settings/sales-channels/route'
import { Route as AuthenticatedSettingsProfileRouteRouteImport } from './routes/_authenticated/settings/profile/route'
import { Route as AuthenticatedSettingsPointsOfSaleRouteRouteImport } from './routes/_authenticated/settings/points-of-sale/route'
import { Route as AuthenticatedSettingsPointOfSaleRouteRouteImport } from './routes/_authenticated/settings/point-of-sale/route'
import { Route as AuthenticatedSettingsMarketingChannelsRouteRouteImport } from './routes/_authenticated/settings/marketing-channels/route'
import { Route as AuthenticatedSettingsInventoryRouteRouteImport } from './routes/_authenticated/settings/inventory/route'
import { Route as AuthenticatedSettingsIntegrationsRouteRouteImport } from './routes/_authenticated/settings/integrations/route'
import { Route as AuthenticatedSettingsExportsRouteRouteImport } from './routes/_authenticated/settings/exports/route'
import { Route as AuthenticatedGeneralPromotionsRouteRouteImport } from './routes/_authenticated/_general/promotions/route'
import { Route as AuthenticatedGeneralProductsRouteRouteImport } from './routes/_authenticated/_general/products/route'
import { Route as AuthenticatedGeneralProductGroupsRouteRouteImport } from './routes/_authenticated/_general/product-groups/route'
import { Route as AuthenticatedGeneralProductCategoriesRouteRouteImport } from './routes/_authenticated/_general/product-categories/route'
import { Route as AuthenticatedGeneralOrdersRouteRouteImport } from './routes/_authenticated/_general/orders/route'
import { Route as AuthenticatedGeneralMarketingRouteRouteImport } from './routes/_authenticated/_general/marketing/route'
import { Route as AuthenticatedGeneralInventoryRouteRouteImport } from './routes/_authenticated/_general/inventory/route'
import { Route as AuthenticatedGeneralCustomersRouteRouteImport } from './routes/_authenticated/_general/customers/route'
import { Route as AuthenticatedGeneralCompaniesRouteRouteImport } from './routes/_authenticated/_general/companies/route'
import { Route as AuthenticatedGeneralAnalyticsRouteRouteImport } from './routes/_authenticated/_general/analytics/route'
import { Route as AuthenticatedSettingsProfileIndexRouteImport } from './routes/_authenticated/settings/profile/index'
import { Route as AuthenticatedSettingsMarketingChannelsIndexRouteImport } from './routes/_authenticated/settings/marketing-channels/index'
import { Route as AuthenticatedSettingsIntegrationsIndexRouteImport } from './routes/_authenticated/settings/integrations/index'
import { Route as AuthenticatedSettingsExportsIndexRouteImport } from './routes/_authenticated/settings/exports/index'
import { Route as AuthenticatedSettingsBillingIndexRouteImport } from './routes/_authenticated/settings/billing/index'
import { Route as AuthenticatedSettingsAccessKeysIndexRouteImport } from './routes/_authenticated/settings/access-keys/index'
import { Route as AuthenticatedGeneralOrdersIndexRouteImport } from './routes/_authenticated/_general/orders/index'
import { Route as AuthenticatedGeneralMarketingIndexRouteImport } from './routes/_authenticated/_general/marketing/index'
import { Route as AuthenticatedGeneralLoyaltyCardsIndexRouteImport } from './routes/_authenticated/_general/loyalty-cards/index'
import { Route as AuthenticatedGeneralGiftCardsIndexRouteImport } from './routes/_authenticated/_general/gift-cards/index'
import { Route as AuthenticatedGeneralBusinessCardsIndexRouteImport } from './routes/_authenticated/_general/business-cards/index'
import { Route as AuthenticatedGeneralAnalyticsIndexRouteImport } from './routes/_authenticated/_general/analytics/index'
import { Route as AuthenticatedSettingsUsersInviteRouteImport } from './routes/_authenticated/settings/users/invite'
import { Route as AuthenticatedSettingsUsersUserUuidRouteImport } from './routes/_authenticated/settings/users/$userUuid'
import { Route as AuthenticatedSettingsSalesChannelsCreateRouteImport } from './routes/_authenticated/settings/sales-channels/create'
import { Route as AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteImport } from './routes/_authenticated/settings/sales-channels/$salesChannelUuid'
import { Route as AuthenticatedSettingsProfileEditRouteImport } from './routes/_authenticated/settings/profile/edit'
import { Route as AuthenticatedSettingsPointsOfSaleCreateRouteImport } from './routes/_authenticated/settings/points-of-sale/create'
import { Route as AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteImport } from './routes/_authenticated/settings/points-of-sale/$pointOfSaleUuid'
import { Route as AuthenticatedSettingsPointOfSaleCreateRouteImport } from './routes/_authenticated/settings/point-of-sale/create'
import { Route as AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteImport } from './routes/_authenticated/settings/point-of-sale/$pointOfSaleUuid'
import { Route as AuthenticatedSettingsIntegrationsProviderRouteImport } from './routes/_authenticated/settings/integrations/$provider'
import { Route as AuthenticatedGeneralPromotionsCreateRouteImport } from './routes/_authenticated/_general/promotions/create'
import { Route as AuthenticatedGeneralPromotionsPromotionUuidRouteImport } from './routes/_authenticated/_general/promotions/$promotionUuid'
import { Route as AuthenticatedGeneralProductsLibraryRouteImport } from './routes/_authenticated/_general/products/library'
import { Route as AuthenticatedGeneralProductsImportRouteImport } from './routes/_authenticated/_general/products/import'
import { Route as AuthenticatedGeneralProductsCreateRouteImport } from './routes/_authenticated/_general/products/create'
import { Route as AuthenticatedGeneralProductsProductUuidRouteImport } from './routes/_authenticated/_general/products/$productUuid'
import { Route as AuthenticatedGeneralProductGroupsCreateRouteImport } from './routes/_authenticated/_general/product-groups/create'
import { Route as AuthenticatedGeneralProductGroupsGroupUuidRouteImport } from './routes/_authenticated/_general/product-groups/$groupUuid'
import { Route as AuthenticatedGeneralProductCategoriesCreateRouteImport } from './routes/_authenticated/_general/product-categories/create'
import { Route as AuthenticatedGeneralProductCategoriesCategoryUuidRouteImport } from './routes/_authenticated/_general/product-categories/$categoryUuid'
import { Route as AuthenticatedGeneralOrdersExportRouteImport } from './routes/_authenticated/_general/orders/export'
import { Route as AuthenticatedGeneralOrdersBagChecksRouteImport } from './routes/_authenticated/_general/orders/bag-checks'
import { Route as AuthenticatedGeneralOrdersOrderUuidRouteImport } from './routes/_authenticated/_general/orders/$orderUuid'
import { Route as AuthenticatedGeneralMarketingMessagingRouteImport } from './routes/_authenticated/_general/marketing/messaging'
import { Route as AuthenticatedGeneralMarketingLibraryRouteImport } from './routes/_authenticated/_general/marketing/library'
import { Route as AuthenticatedGeneralMarketingJourneysRouteImport } from './routes/_authenticated/_general/marketing/journeys'
import { Route as AuthenticatedGeneralMarketingChannelsRouteImport } from './routes/_authenticated/_general/marketing/channels'
import { Route as AuthenticatedGeneralLoyaltyCardsCardUuidRouteImport } from './routes/_authenticated/_general/loyalty-cards/$cardUuid'
import { Route as AuthenticatedGeneralInventoryReportsRouteImport } from './routes/_authenticated/_general/inventory/reports'
import { Route as AuthenticatedGeneralInventoryMovementsRouteImport } from './routes/_authenticated/_general/inventory/movements'
import { Route as AuthenticatedGeneralGiftCardsGiftCardUuidRouteImport } from './routes/_authenticated/_general/gift-cards/$giftCardUuid'
import { Route as AuthenticatedGeneralCustomersCreateRouteImport } from './routes/_authenticated/_general/customers/create'
import { Route as AuthenticatedGeneralCustomersCustomerUuidRouteImport } from './routes/_authenticated/_general/customers/$customerUuid'
import { Route as AuthenticatedGeneralCompaniesCreateRouteImport } from './routes/_authenticated/_general/companies/create'
import { Route as AuthenticatedGeneralCompaniesCompanyUuidRouteImport } from './routes/_authenticated/_general/companies/$companyUuid'
import { Route as AuthenticatedGeneralBusinessCardsCardUuidRouteImport } from './routes/_authenticated/_general/business-cards/$cardUuid'
import { Route as AuthenticatedSettingsSalesChannelsTypesRouteRouteImport } from './routes/_authenticated/settings/sales-channels/types/route'
import { Route as AuthenticatedSettingsSalesChannelsGroupsRouteRouteImport } from './routes/_authenticated/settings/sales-channels/groups/route'
import { Route as AuthenticatedSettingsPointsOfSaleGroupsRouteRouteImport } from './routes/_authenticated/settings/points-of-sale/groups/route'
import { Route as AuthenticatedSettingsPointsOfSaleDevicesRouteRouteImport } from './routes/_authenticated/settings/points-of-sale/devices/route'
import { Route as AuthenticatedGeneralProductsGiftCardsRouteRouteImport } from './routes/_authenticated/_general/products/gift-cards/route'
import { Route as AuthenticatedGeneralInventoryTransfersRouteRouteImport } from './routes/_authenticated/_general/inventory/transfers/route'
import { Route as AuthenticatedGeneralInventorySuppliersRouteRouteImport } from './routes/_authenticated/_general/inventory/suppliers/route'
import { Route as AuthenticatedGeneralInventoryReceivingRouteRouteImport } from './routes/_authenticated/_general/inventory/receiving/route'
import { Route as AuthenticatedGeneralAnalyticsReportsRouteRouteImport } from './routes/_authenticated/_general/analytics/reports/route'
import { Route as AuthenticatedSettingsPointsOfSaleDevicesIndexRouteImport } from './routes/_authenticated/settings/points-of-sale/devices/index'
import { Route as AuthenticatedGeneralMarketingLayoutIndexRouteImport } from './routes/_authenticated/_general/marketing/layout.index'
import { Route as AuthenticatedGeneralMarketingContentIndexRouteImport } from './routes/_authenticated/_general/marketing/content.index'
import { Route as AuthenticatedGeneralAnalyticsReportsIndexRouteImport } from './routes/_authenticated/_general/analytics/reports/index'
import { Route as AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRouteImport } from './routes/_authenticated/settings/users/$userUuid/edit-sign-in-credentials'
import { Route as AuthenticatedSettingsUsersUserUuidEditRouteImport } from './routes/_authenticated/settings/users/$userUuid/edit'
import { Route as AuthenticatedSettingsSalesChannelsTypesCreateRouteImport } from './routes/_authenticated/settings/sales-channels/types/create'
import { Route as AuthenticatedSettingsSalesChannelsGroupsCreateRouteImport } from './routes/_authenticated/settings/sales-channels/groups/create'
import { Route as AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteImport } from './routes/_authenticated/settings/sales-channels/groups/$groupUuid'
import { Route as AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRouteImport } from './routes/_authenticated/settings/sales-channels/$salesChannelUuid/edit'
import { Route as AuthenticatedSettingsPointsOfSaleGroupsCreateRouteImport } from './routes/_authenticated/settings/points-of-sale/groups/create'
import { Route as AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteImport } from './routes/_authenticated/settings/points-of-sale/groups/$groupUuid'
import { Route as AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteImport } from './routes/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid'
import { Route as AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRouteImport } from './routes/_authenticated/settings/points-of-sale/$pointOfSaleUuid/product-menu'
import { Route as AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRouteImport } from './routes/_authenticated/settings/points-of-sale/$pointOfSaleUuid/edit'
import { Route as AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRouteImport } from './routes/_authenticated/settings/point-of-sale/$pointOfSaleUuid/edit'
import { Route as AuthenticatedSettingsInventoryLocationsCreateRouteImport } from './routes/_authenticated/settings/inventory/locations/create'
import { Route as AuthenticatedGeneralPromotionsPromotionUuidEditRouteImport } from './routes/_authenticated/_general/promotions/$promotionUuid/edit'
import { Route as AuthenticatedGeneralProductsGiftCardsCreateRouteImport } from './routes/_authenticated/_general/products/gift-cards/create'
import { Route as AuthenticatedGeneralProductsProductUuidPricesRouteImport } from './routes/_authenticated/_general/products/$productUuid/prices'
import { Route as AuthenticatedGeneralProductsProductUuidOrganizationRouteImport } from './routes/_authenticated/_general/products/$productUuid/organization'
import { Route as AuthenticatedGeneralProductsProductUuidMediaRouteImport } from './routes/_authenticated/_general/products/$productUuid/media'
import { Route as AuthenticatedGeneralProductsProductUuidEditRouteImport } from './routes/_authenticated/_general/products/$productUuid/edit'
import { Route as AuthenticatedGeneralProductGroupsGroupUuidEditRouteImport } from './routes/_authenticated/_general/product-groups/$groupUuid/edit'
import { Route as AuthenticatedGeneralProductCategoriesCategoryUuidEditRouteImport } from './routes/_authenticated/_general/product-categories/$categoryUuid/edit'
import { Route as AuthenticatedGeneralOrdersOrderUuidRefundRouteImport } from './routes/_authenticated/_general/orders/$orderUuid/refund'
import { Route as AuthenticatedGeneralOrdersOrderUuidReceiptRouteImport } from './routes/_authenticated/_general/orders/$orderUuid/receipt'
import { Route as AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRouteImport } from './routes/_authenticated/_general/marketing/layout.$marketingChannelUuid'
import { Route as AuthenticatedGeneralMarketingContentContentUuidRouteImport } from './routes/_authenticated/_general/marketing/content.$contentUuid'
import { Route as AuthenticatedGeneralLoyaltyCardsCardUuidEditRouteImport } from './routes/_authenticated/_general/loyalty-cards/$cardUuid/edit'
import { Route as AuthenticatedGeneralInventoryTransfersCreateRouteImport } from './routes/_authenticated/_general/inventory/transfers/create'
import { Route as AuthenticatedGeneralInventoryTransfersTransferUuidRouteImport } from './routes/_authenticated/_general/inventory/transfers/$transferUuid'
import { Route as AuthenticatedGeneralInventorySuppliersCreateRouteImport } from './routes/_authenticated/_general/inventory/suppliers/create'
import { Route as AuthenticatedGeneralInventoryReceivingCreateRouteImport } from './routes/_authenticated/_general/inventory/receiving/create'
import { Route as AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRouteImport } from './routes/_authenticated/_general/inventory/receiving/$purchaseOrderUuid'
import { Route as AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRouteImport } from './routes/_authenticated/_general/inventory/$inventoryLevelUuid/suppliers'
import { Route as AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRouteImport } from './routes/_authenticated/_general/inventory/$inventoryLevelUuid/adjust'
import { Route as AuthenticatedGeneralGiftCardsGiftCardUuidEditRouteImport } from './routes/_authenticated/_general/gift-cards/$giftCardUuid/edit'
import { Route as AuthenticatedGeneralCustomersCustomerUuidEditRouteImport } from './routes/_authenticated/_general/customers/$customerUuid/edit'
import { Route as AuthenticatedGeneralCompaniesCompanyUuidEditRouteImport } from './routes/_authenticated/_general/companies/$companyUuid/edit'
import { Route as AuthenticatedGeneralBusinessCardsCardUuidEditRouteImport } from './routes/_authenticated/_general/business-cards/$cardUuid/edit'
import { Route as AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRouteImport } from './routes/_authenticated/settings/sales-channels/groups/$groupUuid/edit'
import { Route as AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRouteImport } from './routes/_authenticated/settings/points-of-sale/groups/$groupUuid/edit'
import { Route as AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRouteImport } from './routes/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin'
import { Route as AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRouteImport } from './routes/_authenticated/settings/inventory/locations/$inventoryLocationUuid/edit'
import { Route as AuthenticatedGeneralProductGroupsGroupUuidProductsAddRouteImport } from './routes/_authenticated/_general/product-groups/$groupUuid/products.add'
import { Route as AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRouteImport } from './routes/_authenticated/_general/product-groups/$groupUuid/fees/create'
import { Route as AuthenticatedGeneralInventorySuppliersSupplierUuidEditRouteImport } from './routes/_authenticated/_general/inventory/suppliers/$supplierUuid/edit'
import { Route as AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRouteImport } from './routes/_authenticated/_general/companies/$companyUuid/settlements/create'
import { Route as AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRouteImport } from './routes/_authenticated/_general/product-groups/$groupUuid/fees/$feeUuid.edit'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$splat',
  path: '/$splat',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const AuthenticatedGeneralRouteRoute =
  AuthenticatedGeneralRouteRouteImport.update({
    id: '/_general',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/route.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsUsersRouteRoute =
  AuthenticatedSettingsUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/users/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsSalesChannelsRouteRoute =
  AuthenticatedSettingsSalesChannelsRouteRouteImport.update({
    id: '/sales-channels',
    path: '/sales-channels',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/sales-channels/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsProfileRouteRoute =
  AuthenticatedSettingsProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleRouteRoute =
  AuthenticatedSettingsPointsOfSaleRouteRouteImport.update({
    id: '/points-of-sale',
    path: '/points-of-sale',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/points-of-sale/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsPointOfSaleRouteRoute =
  AuthenticatedSettingsPointOfSaleRouteRouteImport.update({
    id: '/point-of-sale',
    path: '/point-of-sale',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsMarketingChannelsRouteRoute =
  AuthenticatedSettingsMarketingChannelsRouteRouteImport.update({
    id: '/marketing-channels',
    path: '/marketing-channels',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsInventoryRouteRoute =
  AuthenticatedSettingsInventoryRouteRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/inventory/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsIntegrationsRouteRoute =
  AuthenticatedSettingsIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsExportsRouteRoute =
  AuthenticatedSettingsExportsRouteRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedGeneralPromotionsRouteRoute =
  AuthenticatedGeneralPromotionsRouteRouteImport.update({
    id: '/promotions',
    path: '/promotions',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/promotions/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralProductsRouteRoute =
  AuthenticatedGeneralProductsRouteRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/products/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralProductGroupsRouteRoute =
  AuthenticatedGeneralProductGroupsRouteRouteImport.update({
    id: '/product-groups',
    path: '/product-groups',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/product-groups/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralProductCategoriesRouteRoute =
  AuthenticatedGeneralProductCategoriesRouteRouteImport.update({
    id: '/product-categories',
    path: '/product-categories',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/_general/product-categories/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedGeneralOrdersRouteRoute =
  AuthenticatedGeneralOrdersRouteRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/orders/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralMarketingRouteRoute =
  AuthenticatedGeneralMarketingRouteRouteImport.update({
    id: '/marketing',
    path: '/marketing',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryRouteRoute =
  AuthenticatedGeneralInventoryRouteRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/inventory/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralCustomersRouteRoute =
  AuthenticatedGeneralCustomersRouteRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/customers/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralCompaniesRouteRoute =
  AuthenticatedGeneralCompaniesRouteRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_general/companies/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedGeneralAnalyticsRouteRoute =
  AuthenticatedGeneralAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedSettingsProfileIndexRoute =
  AuthenticatedSettingsProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsProfileRouteRoute,
  } as any)
const AuthenticatedSettingsMarketingChannelsIndexRoute =
  AuthenticatedSettingsMarketingChannelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsMarketingChannelsRouteRoute,
  } as any)
const AuthenticatedSettingsIntegrationsIndexRoute =
  AuthenticatedSettingsIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsIntegrationsRouteRoute,
  } as any)
const AuthenticatedSettingsExportsIndexRoute =
  AuthenticatedSettingsExportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsExportsRouteRoute,
  } as any)
const AuthenticatedSettingsBillingIndexRoute =
  AuthenticatedSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccessKeysIndexRoute =
  AuthenticatedSettingsAccessKeysIndexRouteImport.update({
    id: '/access-keys/',
    path: '/access-keys/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedGeneralOrdersIndexRoute =
  AuthenticatedGeneralOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGeneralOrdersRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingIndexRoute =
  AuthenticatedGeneralMarketingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralLoyaltyCardsIndexRoute =
  AuthenticatedGeneralLoyaltyCardsIndexRouteImport.update({
    id: '/loyalty-cards/',
    path: '/loyalty-cards/',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedGeneralGiftCardsIndexRoute =
  AuthenticatedGeneralGiftCardsIndexRouteImport.update({
    id: '/gift-cards/',
    path: '/gift-cards/',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedGeneralBusinessCardsIndexRoute =
  AuthenticatedGeneralBusinessCardsIndexRouteImport.update({
    id: '/business-cards/',
    path: '/business-cards/',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedGeneralAnalyticsIndexRoute =
  AuthenticatedGeneralAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGeneralAnalyticsRouteRoute,
  } as any)
const AuthenticatedSettingsUsersInviteRoute =
  AuthenticatedSettingsUsersInviteRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => AuthenticatedSettingsUsersRouteRoute,
  } as any)
const AuthenticatedSettingsUsersUserUuidRoute =
  AuthenticatedSettingsUsersUserUuidRouteImport.update({
    id: '/$userUuid',
    path: '/$userUuid',
    getParentRoute: () => AuthenticatedSettingsUsersRouteRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsCreateRoute =
  AuthenticatedSettingsSalesChannelsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsRouteRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsSalesChannelUuidRoute =
  AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteImport.update({
    id: '/$salesChannelUuid',
    path: '/$salesChannelUuid',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsRouteRoute,
  } as any)
const AuthenticatedSettingsProfileEditRoute =
  AuthenticatedSettingsProfileEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedSettingsProfileRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleCreateRoute =
  AuthenticatedSettingsPointsOfSaleCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute =
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteImport.update({
    id: '/$pointOfSaleUuid',
    path: '/$pointOfSaleUuid',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleRouteRoute,
  } as any)
const AuthenticatedSettingsPointOfSaleCreateRoute =
  AuthenticatedSettingsPointOfSaleCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsPointOfSaleRouteRoute,
  } as any)
const AuthenticatedSettingsPointOfSalePointOfSaleUuidRoute =
  AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteImport.update({
    id: '/$pointOfSaleUuid',
    path: '/$pointOfSaleUuid',
    getParentRoute: () => AuthenticatedSettingsPointOfSaleRouteRoute,
  } as any)
const AuthenticatedSettingsIntegrationsProviderRoute =
  AuthenticatedSettingsIntegrationsProviderRouteImport.update({
    id: '/$provider',
    path: '/$provider',
    getParentRoute: () => AuthenticatedSettingsIntegrationsRouteRoute,
  } as any)
const AuthenticatedGeneralPromotionsCreateRoute =
  AuthenticatedGeneralPromotionsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralPromotionsRouteRoute,
  } as any)
const AuthenticatedGeneralPromotionsPromotionUuidRoute =
  AuthenticatedGeneralPromotionsPromotionUuidRouteImport.update({
    id: '/$promotionUuid',
    path: '/$promotionUuid',
    getParentRoute: () => AuthenticatedGeneralPromotionsRouteRoute,
  } as any)
const AuthenticatedGeneralProductsLibraryRoute =
  AuthenticatedGeneralProductsLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthenticatedGeneralProductsRouteRoute,
  } as any)
const AuthenticatedGeneralProductsImportRoute =
  AuthenticatedGeneralProductsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedGeneralProductsRouteRoute,
  } as any)
const AuthenticatedGeneralProductsCreateRoute =
  AuthenticatedGeneralProductsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralProductsRouteRoute,
  } as any)
const AuthenticatedGeneralProductsProductUuidRoute =
  AuthenticatedGeneralProductsProductUuidRouteImport.update({
    id: '/$productUuid',
    path: '/$productUuid',
    getParentRoute: () => AuthenticatedGeneralProductsRouteRoute,
  } as any)
const AuthenticatedGeneralProductGroupsCreateRoute =
  AuthenticatedGeneralProductGroupsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralProductGroupsRouteRoute,
  } as any)
const AuthenticatedGeneralProductGroupsGroupUuidRoute =
  AuthenticatedGeneralProductGroupsGroupUuidRouteImport.update({
    id: '/$groupUuid',
    path: '/$groupUuid',
    getParentRoute: () => AuthenticatedGeneralProductGroupsRouteRoute,
  } as any)
const AuthenticatedGeneralProductCategoriesCreateRoute =
  AuthenticatedGeneralProductCategoriesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralProductCategoriesRouteRoute,
  } as any)
const AuthenticatedGeneralProductCategoriesCategoryUuidRoute =
  AuthenticatedGeneralProductCategoriesCategoryUuidRouteImport.update({
    id: '/$categoryUuid',
    path: '/$categoryUuid',
    getParentRoute: () => AuthenticatedGeneralProductCategoriesRouteRoute,
  } as any)
const AuthenticatedGeneralOrdersExportRoute =
  AuthenticatedGeneralOrdersExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedGeneralOrdersRouteRoute,
  } as any)
const AuthenticatedGeneralOrdersBagChecksRoute =
  AuthenticatedGeneralOrdersBagChecksRouteImport.update({
    id: '/bag-checks',
    path: '/bag-checks',
    getParentRoute: () => AuthenticatedGeneralOrdersRouteRoute,
  } as any)
const AuthenticatedGeneralOrdersOrderUuidRoute =
  AuthenticatedGeneralOrdersOrderUuidRouteImport.update({
    id: '/$orderUuid',
    path: '/$orderUuid',
    getParentRoute: () => AuthenticatedGeneralOrdersRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingMessagingRoute =
  AuthenticatedGeneralMarketingMessagingRouteImport.update({
    id: '/messaging',
    path: '/messaging',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingLibraryRoute =
  AuthenticatedGeneralMarketingLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingJourneysRoute =
  AuthenticatedGeneralMarketingJourneysRouteImport.update({
    id: '/journeys',
    path: '/journeys',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingChannelsRoute =
  AuthenticatedGeneralMarketingChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralLoyaltyCardsCardUuidRoute =
  AuthenticatedGeneralLoyaltyCardsCardUuidRouteImport.update({
    id: '/loyalty-cards/$cardUuid',
    path: '/loyalty-cards/$cardUuid',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryReportsRoute =
  AuthenticatedGeneralInventoryReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryMovementsRoute =
  AuthenticatedGeneralInventoryMovementsRouteImport.update({
    id: '/movements',
    path: '/movements',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any)
const AuthenticatedGeneralGiftCardsGiftCardUuidRoute =
  AuthenticatedGeneralGiftCardsGiftCardUuidRouteImport.update({
    id: '/gift-cards/$giftCardUuid',
    path: '/gift-cards/$giftCardUuid',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedGeneralCustomersCreateRoute =
  AuthenticatedGeneralCustomersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralCustomersRouteRoute,
  } as any)
const AuthenticatedGeneralCustomersCustomerUuidRoute =
  AuthenticatedGeneralCustomersCustomerUuidRouteImport.update({
    id: '/$customerUuid',
    path: '/$customerUuid',
    getParentRoute: () => AuthenticatedGeneralCustomersRouteRoute,
  } as any)
const AuthenticatedGeneralCompaniesCreateRoute =
  AuthenticatedGeneralCompaniesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralCompaniesRouteRoute,
  } as any)
const AuthenticatedGeneralCompaniesCompanyUuidRoute =
  AuthenticatedGeneralCompaniesCompanyUuidRouteImport.update({
    id: '/$companyUuid',
    path: '/$companyUuid',
    getParentRoute: () => AuthenticatedGeneralCompaniesRouteRoute,
  } as any)
const AuthenticatedGeneralBusinessCardsCardUuidRoute =
  AuthenticatedGeneralBusinessCardsCardUuidRouteImport.update({
    id: '/business-cards/$cardUuid',
    path: '/business-cards/$cardUuid',
    getParentRoute: () => AuthenticatedGeneralRouteRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsTypesRouteRoute =
  AuthenticatedSettingsSalesChannelsTypesRouteRouteImport.update({
    id: '/types',
    path: '/types',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/settings/sales-channels/types/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedSettingsSalesChannelsGroupsRouteRoute =
  AuthenticatedSettingsSalesChannelsGroupsRouteRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/settings/sales-channels/groups/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedSettingsPointsOfSaleGroupsRouteRoute =
  AuthenticatedSettingsPointsOfSaleGroupsRouteRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/settings/points-of-sale/groups/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedSettingsPointsOfSaleDevicesRouteRoute =
  AuthenticatedSettingsPointsOfSaleDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleRouteRoute,
  } as any)
const AuthenticatedGeneralProductsGiftCardsRouteRoute =
  AuthenticatedGeneralProductsGiftCardsRouteRouteImport.update({
    id: '/gift-cards',
    path: '/gift-cards',
    getParentRoute: () => AuthenticatedGeneralProductsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/_general/products/gift-cards/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedGeneralInventoryTransfersRouteRoute =
  AuthenticatedGeneralInventoryTransfersRouteRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/_general/inventory/transfers/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedGeneralInventorySuppliersRouteRoute =
  AuthenticatedGeneralInventorySuppliersRouteRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/_general/inventory/suppliers/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedGeneralInventoryReceivingRouteRoute =
  AuthenticatedGeneralInventoryReceivingRouteRouteImport.update({
    id: '/receiving',
    path: '/receiving',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/_general/inventory/receiving/route.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedGeneralAnalyticsReportsRouteRoute =
  AuthenticatedGeneralAnalyticsReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedGeneralAnalyticsRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleDevicesIndexRoute =
  AuthenticatedSettingsPointsOfSaleDevicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleDevicesRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingLayoutIndexRoute =
  AuthenticatedGeneralMarketingLayoutIndexRouteImport.update({
    id: '/layout/',
    path: '/layout/',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingContentIndexRoute =
  AuthenticatedGeneralMarketingContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralAnalyticsReportsIndexRoute =
  AuthenticatedGeneralAnalyticsReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGeneralAnalyticsReportsRouteRoute,
  } as any)
const AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute =
  AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRouteImport.update({
    id: '/edit-sign-in-credentials',
    path: '/edit-sign-in-credentials',
    getParentRoute: () => AuthenticatedSettingsUsersUserUuidRoute,
  } as any)
const AuthenticatedSettingsUsersUserUuidEditRoute =
  AuthenticatedSettingsUsersUserUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedSettingsUsersUserUuidRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsTypesCreateRoute =
  AuthenticatedSettingsSalesChannelsTypesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsTypesRouteRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsGroupsCreateRoute =
  AuthenticatedSettingsSalesChannelsGroupsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsGroupsRouteRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsGroupsGroupUuidRoute =
  AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteImport.update({
    id: '/$groupUuid',
    path: '/$groupUuid',
    getParentRoute: () => AuthenticatedSettingsSalesChannelsGroupsRouteRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute =
  AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedSettingsSalesChannelsSalesChannelUuidRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleGroupsCreateRoute =
  AuthenticatedSettingsPointsOfSaleGroupsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleGroupsRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRoute =
  AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteImport.update({
    id: '/$groupUuid',
    path: '/$groupUuid',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleGroupsRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRoute =
  AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteImport.update({
    id: '/$pointOfSaleUuid',
    path: '/$pointOfSaleUuid',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleDevicesRouteRoute,
  } as any)
const AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute =
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRouteImport.update(
    {
      id: '/product-menu',
      path: '/product-menu',
      getParentRoute: () =>
        AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute,
    } as any,
  )
const AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute =
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute,
  } as any)
const AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute =
  AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedSettingsPointOfSalePointOfSaleUuidRoute,
  } as any)
const AuthenticatedSettingsInventoryLocationsCreateRoute =
  AuthenticatedSettingsInventoryLocationsCreateRouteImport.update({
    id: '/locations/create',
    path: '/locations/create',
    getParentRoute: () => AuthenticatedSettingsInventoryRouteRoute,
  } as any)
const AuthenticatedGeneralPromotionsPromotionUuidEditRoute =
  AuthenticatedGeneralPromotionsPromotionUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralPromotionsPromotionUuidRoute,
  } as any)
const AuthenticatedGeneralProductsGiftCardsCreateRoute =
  AuthenticatedGeneralProductsGiftCardsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralProductsGiftCardsRouteRoute,
  } as any)
const AuthenticatedGeneralProductsProductUuidPricesRoute =
  AuthenticatedGeneralProductsProductUuidPricesRouteImport.update({
    id: '/prices',
    path: '/prices',
    getParentRoute: () => AuthenticatedGeneralProductsProductUuidRoute,
  } as any)
const AuthenticatedGeneralProductsProductUuidOrganizationRoute =
  AuthenticatedGeneralProductsProductUuidOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedGeneralProductsProductUuidRoute,
  } as any)
const AuthenticatedGeneralProductsProductUuidMediaRoute =
  AuthenticatedGeneralProductsProductUuidMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AuthenticatedGeneralProductsProductUuidRoute,
  } as any)
const AuthenticatedGeneralProductsProductUuidEditRoute =
  AuthenticatedGeneralProductsProductUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralProductsProductUuidRoute,
  } as any)
const AuthenticatedGeneralProductGroupsGroupUuidEditRoute =
  AuthenticatedGeneralProductGroupsGroupUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralProductGroupsGroupUuidRoute,
  } as any)
const AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute =
  AuthenticatedGeneralProductCategoriesCategoryUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedGeneralProductCategoriesCategoryUuidRoute,
  } as any)
const AuthenticatedGeneralOrdersOrderUuidRefundRoute =
  AuthenticatedGeneralOrdersOrderUuidRefundRouteImport.update({
    id: '/refund',
    path: '/refund',
    getParentRoute: () => AuthenticatedGeneralOrdersOrderUuidRoute,
  } as any)
const AuthenticatedGeneralOrdersOrderUuidReceiptRoute =
  AuthenticatedGeneralOrdersOrderUuidReceiptRouteImport.update({
    id: '/receipt',
    path: '/receipt',
    getParentRoute: () => AuthenticatedGeneralOrdersOrderUuidRoute,
  } as any)
const AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute =
  AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRouteImport.update({
    id: '/layout/$marketingChannelUuid',
    path: '/layout/$marketingChannelUuid',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralMarketingContentContentUuidRoute =
  AuthenticatedGeneralMarketingContentContentUuidRouteImport.update({
    id: '/content/$contentUuid',
    path: '/content/$contentUuid',
    getParentRoute: () => AuthenticatedGeneralMarketingRouteRoute,
  } as any)
const AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute =
  AuthenticatedGeneralLoyaltyCardsCardUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralLoyaltyCardsCardUuidRoute,
  } as any)
const AuthenticatedGeneralInventoryTransfersCreateRoute =
  AuthenticatedGeneralInventoryTransfersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralInventoryTransfersRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryTransfersTransferUuidRoute =
  AuthenticatedGeneralInventoryTransfersTransferUuidRouteImport.update({
    id: '/$transferUuid',
    path: '/$transferUuid',
    getParentRoute: () => AuthenticatedGeneralInventoryTransfersRouteRoute,
  } as any)
const AuthenticatedGeneralInventorySuppliersCreateRoute =
  AuthenticatedGeneralInventorySuppliersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralInventorySuppliersRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryReceivingCreateRoute =
  AuthenticatedGeneralInventoryReceivingCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedGeneralInventoryReceivingRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute =
  AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRouteImport.update({
    id: '/$purchaseOrderUuid',
    path: '/$purchaseOrderUuid',
    getParentRoute: () => AuthenticatedGeneralInventoryReceivingRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute =
  AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRouteImport.update({
    id: '/$inventoryLevelUuid/suppliers',
    path: '/$inventoryLevelUuid/suppliers',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any)
const AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute =
  AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRouteImport.update({
    id: '/$inventoryLevelUuid/adjust',
    path: '/$inventoryLevelUuid/adjust',
    getParentRoute: () => AuthenticatedGeneralInventoryRouteRoute,
  } as any)
const AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute =
  AuthenticatedGeneralGiftCardsGiftCardUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralGiftCardsGiftCardUuidRoute,
  } as any)
const AuthenticatedGeneralCustomersCustomerUuidEditRoute =
  AuthenticatedGeneralCustomersCustomerUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralCustomersCustomerUuidRoute,
  } as any)
const AuthenticatedGeneralCompaniesCompanyUuidEditRoute =
  AuthenticatedGeneralCompaniesCompanyUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralCompaniesCompanyUuidRoute,
  } as any)
const AuthenticatedGeneralBusinessCardsCardUuidEditRoute =
  AuthenticatedGeneralBusinessCardsCardUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedGeneralBusinessCardsCardUuidRoute,
  } as any)
const AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute =
  AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedSettingsSalesChannelsGroupsGroupUuidRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute =
  AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRoute,
  } as any)
const AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute =
  AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRouteImport.update(
    {
      id: '/edit-unlock-pin',
      path: '/edit-unlock-pin',
      getParentRoute: () =>
        AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRoute,
    } as any,
  )
const AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute =
  AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRouteImport.update(
    {
      id: '/locations/$inventoryLocationUuid/edit',
      path: '/locations/$inventoryLocationUuid/edit',
      getParentRoute: () => AuthenticatedSettingsInventoryRouteRoute,
    } as any,
  )
const AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute =
  AuthenticatedGeneralProductGroupsGroupUuidProductsAddRouteImport.update({
    id: '/products/add',
    path: '/products/add',
    getParentRoute: () => AuthenticatedGeneralProductGroupsGroupUuidRoute,
  } as any)
const AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute =
  AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRouteImport.update({
    id: '/fees/create',
    path: '/fees/create',
    getParentRoute: () => AuthenticatedGeneralProductGroupsGroupUuidRoute,
  } as any)
const AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute =
  AuthenticatedGeneralInventorySuppliersSupplierUuidEditRouteImport.update({
    id: '/$supplierUuid/edit',
    path: '/$supplierUuid/edit',
    getParentRoute: () => AuthenticatedGeneralInventorySuppliersRouteRoute,
  } as any)
const AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute =
  AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRouteImport.update({
    id: '/settlements/create',
    path: '/settlements/create',
    getParentRoute: () => AuthenticatedGeneralCompaniesCompanyUuidRoute,
  } as any)
const AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute =
  AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRouteImport.update({
    id: '/fees/$feeUuid/edit',
    path: '/fees/$feeUuid/edit',
    getParentRoute: () => AuthenticatedGeneralProductGroupsGroupUuidRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$splat': typeof SplatRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/analytics': typeof AuthenticatedGeneralAnalyticsRouteRouteWithChildren
  '/companies': typeof AuthenticatedGeneralCompaniesRouteRouteWithChildren
  '/customers': typeof AuthenticatedGeneralCustomersRouteRouteWithChildren
  '/inventory': typeof AuthenticatedGeneralInventoryRouteRouteWithChildren
  '/marketing': typeof AuthenticatedGeneralMarketingRouteRouteWithChildren
  '/orders': typeof AuthenticatedGeneralOrdersRouteRouteWithChildren
  '/product-categories': typeof AuthenticatedGeneralProductCategoriesRouteRouteWithChildren
  '/product-groups': typeof AuthenticatedGeneralProductGroupsRouteRouteWithChildren
  '/products': typeof AuthenticatedGeneralProductsRouteRouteWithChildren
  '/promotions': typeof AuthenticatedGeneralPromotionsRouteRouteWithChildren
  '/settings/exports': typeof AuthenticatedSettingsExportsRouteRouteWithChildren
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRouteRouteWithChildren
  '/settings/inventory': typeof AuthenticatedSettingsInventoryRouteRouteWithChildren
  '/settings/marketing-channels': typeof AuthenticatedSettingsMarketingChannelsRouteRouteWithChildren
  '/settings/point-of-sale': typeof AuthenticatedSettingsPointOfSaleRouteRouteWithChildren
  '/settings/points-of-sale': typeof AuthenticatedSettingsPointsOfSaleRouteRouteWithChildren
  '/settings/profile': typeof AuthenticatedSettingsProfileRouteRouteWithChildren
  '/settings/sales-channels': typeof AuthenticatedSettingsSalesChannelsRouteRouteWithChildren
  '/settings/users': typeof AuthenticatedSettingsUsersRouteRouteWithChildren
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/analytics/reports': typeof AuthenticatedGeneralAnalyticsReportsRouteRouteWithChildren
  '/inventory/receiving': typeof AuthenticatedGeneralInventoryReceivingRouteRouteWithChildren
  '/inventory/suppliers': typeof AuthenticatedGeneralInventorySuppliersRouteRouteWithChildren
  '/inventory/transfers': typeof AuthenticatedGeneralInventoryTransfersRouteRouteWithChildren
  '/products/gift-cards': typeof AuthenticatedGeneralProductsGiftCardsRouteRouteWithChildren
  '/settings/points-of-sale/devices': typeof AuthenticatedSettingsPointsOfSaleDevicesRouteRouteWithChildren
  '/settings/points-of-sale/groups': typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRouteWithChildren
  '/settings/sales-channels/groups': typeof AuthenticatedSettingsSalesChannelsGroupsRouteRouteWithChildren
  '/settings/sales-channels/types': typeof AuthenticatedSettingsSalesChannelsTypesRouteRouteWithChildren
  '/business-cards/$cardUuid': typeof AuthenticatedGeneralBusinessCardsCardUuidRouteWithChildren
  '/companies/$companyUuid': typeof AuthenticatedGeneralCompaniesCompanyUuidRouteWithChildren
  '/companies/create': typeof AuthenticatedGeneralCompaniesCreateRoute
  '/customers/$customerUuid': typeof AuthenticatedGeneralCustomersCustomerUuidRouteWithChildren
  '/customers/create': typeof AuthenticatedGeneralCustomersCreateRoute
  '/gift-cards/$giftCardUuid': typeof AuthenticatedGeneralGiftCardsGiftCardUuidRouteWithChildren
  '/inventory/movements': typeof AuthenticatedGeneralInventoryMovementsRoute
  '/inventory/reports': typeof AuthenticatedGeneralInventoryReportsRoute
  '/loyalty-cards/$cardUuid': typeof AuthenticatedGeneralLoyaltyCardsCardUuidRouteWithChildren
  '/marketing/channels': typeof AuthenticatedGeneralMarketingChannelsRoute
  '/marketing/journeys': typeof AuthenticatedGeneralMarketingJourneysRoute
  '/marketing/library': typeof AuthenticatedGeneralMarketingLibraryRoute
  '/marketing/messaging': typeof AuthenticatedGeneralMarketingMessagingRoute
  '/orders/$orderUuid': typeof AuthenticatedGeneralOrdersOrderUuidRouteWithChildren
  '/orders/bag-checks': typeof AuthenticatedGeneralOrdersBagChecksRoute
  '/orders/export': typeof AuthenticatedGeneralOrdersExportRoute
  '/product-categories/$categoryUuid': typeof AuthenticatedGeneralProductCategoriesCategoryUuidRouteWithChildren
  '/product-categories/create': typeof AuthenticatedGeneralProductCategoriesCreateRoute
  '/product-groups/$groupUuid': typeof AuthenticatedGeneralProductGroupsGroupUuidRouteWithChildren
  '/product-groups/create': typeof AuthenticatedGeneralProductGroupsCreateRoute
  '/products/$productUuid': typeof AuthenticatedGeneralProductsProductUuidRouteWithChildren
  '/products/create': typeof AuthenticatedGeneralProductsCreateRoute
  '/products/import': typeof AuthenticatedGeneralProductsImportRoute
  '/products/library': typeof AuthenticatedGeneralProductsLibraryRoute
  '/promotions/$promotionUuid': typeof AuthenticatedGeneralPromotionsPromotionUuidRouteWithChildren
  '/promotions/create': typeof AuthenticatedGeneralPromotionsCreateRoute
  '/settings/integrations/$provider': typeof AuthenticatedSettingsIntegrationsProviderRoute
  '/settings/point-of-sale/$pointOfSaleUuid': typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteWithChildren
  '/settings/point-of-sale/create': typeof AuthenticatedSettingsPointOfSaleCreateRoute
  '/settings/points-of-sale/$pointOfSaleUuid': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteWithChildren
  '/settings/points-of-sale/create': typeof AuthenticatedSettingsPointsOfSaleCreateRoute
  '/settings/profile/edit': typeof AuthenticatedSettingsProfileEditRoute
  '/settings/sales-channels/$salesChannelUuid': typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteWithChildren
  '/settings/sales-channels/create': typeof AuthenticatedSettingsSalesChannelsCreateRoute
  '/settings/users/$userUuid': typeof AuthenticatedSettingsUsersUserUuidRouteWithChildren
  '/settings/users/invite': typeof AuthenticatedSettingsUsersInviteRoute
  '/analytics/': typeof AuthenticatedGeneralAnalyticsIndexRoute
  '/business-cards': typeof AuthenticatedGeneralBusinessCardsIndexRoute
  '/gift-cards': typeof AuthenticatedGeneralGiftCardsIndexRoute
  '/loyalty-cards': typeof AuthenticatedGeneralLoyaltyCardsIndexRoute
  '/marketing/': typeof AuthenticatedGeneralMarketingIndexRoute
  '/orders/': typeof AuthenticatedGeneralOrdersIndexRoute
  '/settings/access-keys': typeof AuthenticatedSettingsAccessKeysIndexRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingIndexRoute
  '/settings/exports/': typeof AuthenticatedSettingsExportsIndexRoute
  '/settings/integrations/': typeof AuthenticatedSettingsIntegrationsIndexRoute
  '/settings/marketing-channels/': typeof AuthenticatedSettingsMarketingChannelsIndexRoute
  '/settings/profile/': typeof AuthenticatedSettingsProfileIndexRoute
  '/business-cards/$cardUuid/edit': typeof AuthenticatedGeneralBusinessCardsCardUuidEditRoute
  '/companies/$companyUuid/edit': typeof AuthenticatedGeneralCompaniesCompanyUuidEditRoute
  '/customers/$customerUuid/edit': typeof AuthenticatedGeneralCustomersCustomerUuidEditRoute
  '/gift-cards/$giftCardUuid/edit': typeof AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute
  '/inventory/$inventoryLevelUuid/adjust': typeof AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute
  '/inventory/$inventoryLevelUuid/suppliers': typeof AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute
  '/inventory/receiving/$purchaseOrderUuid': typeof AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute
  '/inventory/receiving/create': typeof AuthenticatedGeneralInventoryReceivingCreateRoute
  '/inventory/suppliers/create': typeof AuthenticatedGeneralInventorySuppliersCreateRoute
  '/inventory/transfers/$transferUuid': typeof AuthenticatedGeneralInventoryTransfersTransferUuidRoute
  '/inventory/transfers/create': typeof AuthenticatedGeneralInventoryTransfersCreateRoute
  '/loyalty-cards/$cardUuid/edit': typeof AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute
  '/marketing/content/$contentUuid': typeof AuthenticatedGeneralMarketingContentContentUuidRoute
  '/marketing/layout/$marketingChannelUuid': typeof AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute
  '/orders/$orderUuid/receipt': typeof AuthenticatedGeneralOrdersOrderUuidReceiptRoute
  '/orders/$orderUuid/refund': typeof AuthenticatedGeneralOrdersOrderUuidRefundRoute
  '/product-categories/$categoryUuid/edit': typeof AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute
  '/product-groups/$groupUuid/edit': typeof AuthenticatedGeneralProductGroupsGroupUuidEditRoute
  '/products/$productUuid/edit': typeof AuthenticatedGeneralProductsProductUuidEditRoute
  '/products/$productUuid/media': typeof AuthenticatedGeneralProductsProductUuidMediaRoute
  '/products/$productUuid/organization': typeof AuthenticatedGeneralProductsProductUuidOrganizationRoute
  '/products/$productUuid/prices': typeof AuthenticatedGeneralProductsProductUuidPricesRoute
  '/products/gift-cards/create': typeof AuthenticatedGeneralProductsGiftCardsCreateRoute
  '/promotions/$promotionUuid/edit': typeof AuthenticatedGeneralPromotionsPromotionUuidEditRoute
  '/settings/inventory/locations/create': typeof AuthenticatedSettingsInventoryLocationsCreateRoute
  '/settings/point-of-sale/$pointOfSaleUuid/edit': typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute
  '/settings/points-of-sale/$pointOfSaleUuid/edit': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute
  '/settings/points-of-sale/$pointOfSaleUuid/product-menu': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute
  '/settings/points-of-sale/devices/$pointOfSaleUuid': typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteWithChildren
  '/settings/points-of-sale/groups/$groupUuid': typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteWithChildren
  '/settings/points-of-sale/groups/create': typeof AuthenticatedSettingsPointsOfSaleGroupsCreateRoute
  '/settings/sales-channels/$salesChannelUuid/edit': typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute
  '/settings/sales-channels/groups/$groupUuid': typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteWithChildren
  '/settings/sales-channels/groups/create': typeof AuthenticatedSettingsSalesChannelsGroupsCreateRoute
  '/settings/sales-channels/types/create': typeof AuthenticatedSettingsSalesChannelsTypesCreateRoute
  '/settings/users/$userUuid/edit': typeof AuthenticatedSettingsUsersUserUuidEditRoute
  '/settings/users/$userUuid/edit-sign-in-credentials': typeof AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute
  '/analytics/reports/': typeof AuthenticatedGeneralAnalyticsReportsIndexRoute
  '/marketing/content': typeof AuthenticatedGeneralMarketingContentIndexRoute
  '/marketing/layout': typeof AuthenticatedGeneralMarketingLayoutIndexRoute
  '/settings/points-of-sale/devices/': typeof AuthenticatedSettingsPointsOfSaleDevicesIndexRoute
  '/companies/$companyUuid/settlements/create': typeof AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute
  '/inventory/suppliers/$supplierUuid/edit': typeof AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute
  '/product-groups/$groupUuid/fees/create': typeof AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute
  '/product-groups/$groupUuid/products/add': typeof AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute
  '/settings/inventory/locations/$inventoryLocationUuid/edit': typeof AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute
  '/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin': typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute
  '/settings/points-of-sale/groups/$groupUuid/edit': typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute
  '/settings/sales-channels/groups/$groupUuid/edit': typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute
  '/product-groups/$groupUuid/fees/$feeUuid/edit': typeof AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$splat': typeof SplatRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/companies': typeof AuthenticatedGeneralCompaniesRouteRouteWithChildren
  '/customers': typeof AuthenticatedGeneralCustomersRouteRouteWithChildren
  '/inventory': typeof AuthenticatedGeneralInventoryRouteRouteWithChildren
  '/product-categories': typeof AuthenticatedGeneralProductCategoriesRouteRouteWithChildren
  '/product-groups': typeof AuthenticatedGeneralProductGroupsRouteRouteWithChildren
  '/products': typeof AuthenticatedGeneralProductsRouteRouteWithChildren
  '/promotions': typeof AuthenticatedGeneralPromotionsRouteRouteWithChildren
  '/settings/inventory': typeof AuthenticatedSettingsInventoryRouteRouteWithChildren
  '/settings/point-of-sale': typeof AuthenticatedSettingsPointOfSaleRouteRouteWithChildren
  '/settings/points-of-sale': typeof AuthenticatedSettingsPointsOfSaleRouteRouteWithChildren
  '/settings/sales-channels': typeof AuthenticatedSettingsSalesChannelsRouteRouteWithChildren
  '/settings/users': typeof AuthenticatedSettingsUsersRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/inventory/receiving': typeof AuthenticatedGeneralInventoryReceivingRouteRouteWithChildren
  '/inventory/suppliers': typeof AuthenticatedGeneralInventorySuppliersRouteRouteWithChildren
  '/inventory/transfers': typeof AuthenticatedGeneralInventoryTransfersRouteRouteWithChildren
  '/products/gift-cards': typeof AuthenticatedGeneralProductsGiftCardsRouteRouteWithChildren
  '/settings/points-of-sale/groups': typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRouteWithChildren
  '/settings/sales-channels/groups': typeof AuthenticatedSettingsSalesChannelsGroupsRouteRouteWithChildren
  '/settings/sales-channels/types': typeof AuthenticatedSettingsSalesChannelsTypesRouteRouteWithChildren
  '/business-cards/$cardUuid': typeof AuthenticatedGeneralBusinessCardsCardUuidRouteWithChildren
  '/companies/$companyUuid': typeof AuthenticatedGeneralCompaniesCompanyUuidRouteWithChildren
  '/companies/create': typeof AuthenticatedGeneralCompaniesCreateRoute
  '/customers/$customerUuid': typeof AuthenticatedGeneralCustomersCustomerUuidRouteWithChildren
  '/customers/create': typeof AuthenticatedGeneralCustomersCreateRoute
  '/gift-cards/$giftCardUuid': typeof AuthenticatedGeneralGiftCardsGiftCardUuidRouteWithChildren
  '/inventory/movements': typeof AuthenticatedGeneralInventoryMovementsRoute
  '/inventory/reports': typeof AuthenticatedGeneralInventoryReportsRoute
  '/loyalty-cards/$cardUuid': typeof AuthenticatedGeneralLoyaltyCardsCardUuidRouteWithChildren
  '/marketing/channels': typeof AuthenticatedGeneralMarketingChannelsRoute
  '/marketing/journeys': typeof AuthenticatedGeneralMarketingJourneysRoute
  '/marketing/library': typeof AuthenticatedGeneralMarketingLibraryRoute
  '/marketing/messaging': typeof AuthenticatedGeneralMarketingMessagingRoute
  '/orders/$orderUuid': typeof AuthenticatedGeneralOrdersOrderUuidRouteWithChildren
  '/orders/bag-checks': typeof AuthenticatedGeneralOrdersBagChecksRoute
  '/orders/export': typeof AuthenticatedGeneralOrdersExportRoute
  '/product-categories/$categoryUuid': typeof AuthenticatedGeneralProductCategoriesCategoryUuidRouteWithChildren
  '/product-categories/create': typeof AuthenticatedGeneralProductCategoriesCreateRoute
  '/product-groups/$groupUuid': typeof AuthenticatedGeneralProductGroupsGroupUuidRouteWithChildren
  '/product-groups/create': typeof AuthenticatedGeneralProductGroupsCreateRoute
  '/products/$productUuid': typeof AuthenticatedGeneralProductsProductUuidRouteWithChildren
  '/products/create': typeof AuthenticatedGeneralProductsCreateRoute
  '/products/import': typeof AuthenticatedGeneralProductsImportRoute
  '/products/library': typeof AuthenticatedGeneralProductsLibraryRoute
  '/promotions/$promotionUuid': typeof AuthenticatedGeneralPromotionsPromotionUuidRouteWithChildren
  '/promotions/create': typeof AuthenticatedGeneralPromotionsCreateRoute
  '/settings/integrations/$provider': typeof AuthenticatedSettingsIntegrationsProviderRoute
  '/settings/point-of-sale/$pointOfSaleUuid': typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteWithChildren
  '/settings/point-of-sale/create': typeof AuthenticatedSettingsPointOfSaleCreateRoute
  '/settings/points-of-sale/$pointOfSaleUuid': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteWithChildren
  '/settings/points-of-sale/create': typeof AuthenticatedSettingsPointsOfSaleCreateRoute
  '/settings/profile/edit': typeof AuthenticatedSettingsProfileEditRoute
  '/settings/sales-channels/$salesChannelUuid': typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteWithChildren
  '/settings/sales-channels/create': typeof AuthenticatedSettingsSalesChannelsCreateRoute
  '/settings/users/$userUuid': typeof AuthenticatedSettingsUsersUserUuidRouteWithChildren
  '/settings/users/invite': typeof AuthenticatedSettingsUsersInviteRoute
  '/analytics': typeof AuthenticatedGeneralAnalyticsIndexRoute
  '/business-cards': typeof AuthenticatedGeneralBusinessCardsIndexRoute
  '/gift-cards': typeof AuthenticatedGeneralGiftCardsIndexRoute
  '/loyalty-cards': typeof AuthenticatedGeneralLoyaltyCardsIndexRoute
  '/marketing': typeof AuthenticatedGeneralMarketingIndexRoute
  '/orders': typeof AuthenticatedGeneralOrdersIndexRoute
  '/settings/access-keys': typeof AuthenticatedSettingsAccessKeysIndexRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingIndexRoute
  '/settings/exports': typeof AuthenticatedSettingsExportsIndexRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsIndexRoute
  '/settings/marketing-channels': typeof AuthenticatedSettingsMarketingChannelsIndexRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileIndexRoute
  '/business-cards/$cardUuid/edit': typeof AuthenticatedGeneralBusinessCardsCardUuidEditRoute
  '/companies/$companyUuid/edit': typeof AuthenticatedGeneralCompaniesCompanyUuidEditRoute
  '/customers/$customerUuid/edit': typeof AuthenticatedGeneralCustomersCustomerUuidEditRoute
  '/gift-cards/$giftCardUuid/edit': typeof AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute
  '/inventory/$inventoryLevelUuid/adjust': typeof AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute
  '/inventory/$inventoryLevelUuid/suppliers': typeof AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute
  '/inventory/receiving/$purchaseOrderUuid': typeof AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute
  '/inventory/receiving/create': typeof AuthenticatedGeneralInventoryReceivingCreateRoute
  '/inventory/suppliers/create': typeof AuthenticatedGeneralInventorySuppliersCreateRoute
  '/inventory/transfers/$transferUuid': typeof AuthenticatedGeneralInventoryTransfersTransferUuidRoute
  '/inventory/transfers/create': typeof AuthenticatedGeneralInventoryTransfersCreateRoute
  '/loyalty-cards/$cardUuid/edit': typeof AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute
  '/marketing/content/$contentUuid': typeof AuthenticatedGeneralMarketingContentContentUuidRoute
  '/marketing/layout/$marketingChannelUuid': typeof AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute
  '/orders/$orderUuid/receipt': typeof AuthenticatedGeneralOrdersOrderUuidReceiptRoute
  '/orders/$orderUuid/refund': typeof AuthenticatedGeneralOrdersOrderUuidRefundRoute
  '/product-categories/$categoryUuid/edit': typeof AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute
  '/product-groups/$groupUuid/edit': typeof AuthenticatedGeneralProductGroupsGroupUuidEditRoute
  '/products/$productUuid/edit': typeof AuthenticatedGeneralProductsProductUuidEditRoute
  '/products/$productUuid/media': typeof AuthenticatedGeneralProductsProductUuidMediaRoute
  '/products/$productUuid/organization': typeof AuthenticatedGeneralProductsProductUuidOrganizationRoute
  '/products/$productUuid/prices': typeof AuthenticatedGeneralProductsProductUuidPricesRoute
  '/products/gift-cards/create': typeof AuthenticatedGeneralProductsGiftCardsCreateRoute
  '/promotions/$promotionUuid/edit': typeof AuthenticatedGeneralPromotionsPromotionUuidEditRoute
  '/settings/inventory/locations/create': typeof AuthenticatedSettingsInventoryLocationsCreateRoute
  '/settings/point-of-sale/$pointOfSaleUuid/edit': typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute
  '/settings/points-of-sale/$pointOfSaleUuid/edit': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute
  '/settings/points-of-sale/$pointOfSaleUuid/product-menu': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute
  '/settings/points-of-sale/devices/$pointOfSaleUuid': typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteWithChildren
  '/settings/points-of-sale/groups/$groupUuid': typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteWithChildren
  '/settings/points-of-sale/groups/create': typeof AuthenticatedSettingsPointsOfSaleGroupsCreateRoute
  '/settings/sales-channels/$salesChannelUuid/edit': typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute
  '/settings/sales-channels/groups/$groupUuid': typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteWithChildren
  '/settings/sales-channels/groups/create': typeof AuthenticatedSettingsSalesChannelsGroupsCreateRoute
  '/settings/sales-channels/types/create': typeof AuthenticatedSettingsSalesChannelsTypesCreateRoute
  '/settings/users/$userUuid/edit': typeof AuthenticatedSettingsUsersUserUuidEditRoute
  '/settings/users/$userUuid/edit-sign-in-credentials': typeof AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute
  '/analytics/reports': typeof AuthenticatedGeneralAnalyticsReportsIndexRoute
  '/marketing/content': typeof AuthenticatedGeneralMarketingContentIndexRoute
  '/marketing/layout': typeof AuthenticatedGeneralMarketingLayoutIndexRoute
  '/settings/points-of-sale/devices': typeof AuthenticatedSettingsPointsOfSaleDevicesIndexRoute
  '/companies/$companyUuid/settlements/create': typeof AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute
  '/inventory/suppliers/$supplierUuid/edit': typeof AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute
  '/product-groups/$groupUuid/fees/create': typeof AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute
  '/product-groups/$groupUuid/products/add': typeof AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute
  '/settings/inventory/locations/$inventoryLocationUuid/edit': typeof AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute
  '/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin': typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute
  '/settings/points-of-sale/groups/$groupUuid/edit': typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute
  '/settings/sales-channels/groups/$groupUuid/edit': typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute
  '/product-groups/$groupUuid/fees/$feeUuid/edit': typeof AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$splat': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/_general': typeof AuthenticatedGeneralRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/_general/analytics': typeof AuthenticatedGeneralAnalyticsRouteRouteWithChildren
  '/_authenticated/_general/companies': typeof AuthenticatedGeneralCompaniesRouteRouteWithChildren
  '/_authenticated/_general/customers': typeof AuthenticatedGeneralCustomersRouteRouteWithChildren
  '/_authenticated/_general/inventory': typeof AuthenticatedGeneralInventoryRouteRouteWithChildren
  '/_authenticated/_general/marketing': typeof AuthenticatedGeneralMarketingRouteRouteWithChildren
  '/_authenticated/_general/orders': typeof AuthenticatedGeneralOrdersRouteRouteWithChildren
  '/_authenticated/_general/product-categories': typeof AuthenticatedGeneralProductCategoriesRouteRouteWithChildren
  '/_authenticated/_general/product-groups': typeof AuthenticatedGeneralProductGroupsRouteRouteWithChildren
  '/_authenticated/_general/products': typeof AuthenticatedGeneralProductsRouteRouteWithChildren
  '/_authenticated/_general/promotions': typeof AuthenticatedGeneralPromotionsRouteRouteWithChildren
  '/_authenticated/settings/exports': typeof AuthenticatedSettingsExportsRouteRouteWithChildren
  '/_authenticated/settings/integrations': typeof AuthenticatedSettingsIntegrationsRouteRouteWithChildren
  '/_authenticated/settings/inventory': typeof AuthenticatedSettingsInventoryRouteRouteWithChildren
  '/_authenticated/settings/marketing-channels': typeof AuthenticatedSettingsMarketingChannelsRouteRouteWithChildren
  '/_authenticated/settings/point-of-sale': typeof AuthenticatedSettingsPointOfSaleRouteRouteWithChildren
  '/_authenticated/settings/points-of-sale': typeof AuthenticatedSettingsPointsOfSaleRouteRouteWithChildren
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRouteRouteWithChildren
  '/_authenticated/settings/sales-channels': typeof AuthenticatedSettingsSalesChannelsRouteRouteWithChildren
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRouteRouteWithChildren
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/_general/analytics/reports': typeof AuthenticatedGeneralAnalyticsReportsRouteRouteWithChildren
  '/_authenticated/_general/inventory/receiving': typeof AuthenticatedGeneralInventoryReceivingRouteRouteWithChildren
  '/_authenticated/_general/inventory/suppliers': typeof AuthenticatedGeneralInventorySuppliersRouteRouteWithChildren
  '/_authenticated/_general/inventory/transfers': typeof AuthenticatedGeneralInventoryTransfersRouteRouteWithChildren
  '/_authenticated/_general/products/gift-cards': typeof AuthenticatedGeneralProductsGiftCardsRouteRouteWithChildren
  '/_authenticated/settings/points-of-sale/devices': typeof AuthenticatedSettingsPointsOfSaleDevicesRouteRouteWithChildren
  '/_authenticated/settings/points-of-sale/groups': typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRouteWithChildren
  '/_authenticated/settings/sales-channels/groups': typeof AuthenticatedSettingsSalesChannelsGroupsRouteRouteWithChildren
  '/_authenticated/settings/sales-channels/types': typeof AuthenticatedSettingsSalesChannelsTypesRouteRouteWithChildren
  '/_authenticated/_general/business-cards/$cardUuid': typeof AuthenticatedGeneralBusinessCardsCardUuidRouteWithChildren
  '/_authenticated/_general/companies/$companyUuid': typeof AuthenticatedGeneralCompaniesCompanyUuidRouteWithChildren
  '/_authenticated/_general/companies/create': typeof AuthenticatedGeneralCompaniesCreateRoute
  '/_authenticated/_general/customers/$customerUuid': typeof AuthenticatedGeneralCustomersCustomerUuidRouteWithChildren
  '/_authenticated/_general/customers/create': typeof AuthenticatedGeneralCustomersCreateRoute
  '/_authenticated/_general/gift-cards/$giftCardUuid': typeof AuthenticatedGeneralGiftCardsGiftCardUuidRouteWithChildren
  '/_authenticated/_general/inventory/movements': typeof AuthenticatedGeneralInventoryMovementsRoute
  '/_authenticated/_general/inventory/reports': typeof AuthenticatedGeneralInventoryReportsRoute
  '/_authenticated/_general/loyalty-cards/$cardUuid': typeof AuthenticatedGeneralLoyaltyCardsCardUuidRouteWithChildren
  '/_authenticated/_general/marketing/channels': typeof AuthenticatedGeneralMarketingChannelsRoute
  '/_authenticated/_general/marketing/journeys': typeof AuthenticatedGeneralMarketingJourneysRoute
  '/_authenticated/_general/marketing/library': typeof AuthenticatedGeneralMarketingLibraryRoute
  '/_authenticated/_general/marketing/messaging': typeof AuthenticatedGeneralMarketingMessagingRoute
  '/_authenticated/_general/orders/$orderUuid': typeof AuthenticatedGeneralOrdersOrderUuidRouteWithChildren
  '/_authenticated/_general/orders/bag-checks': typeof AuthenticatedGeneralOrdersBagChecksRoute
  '/_authenticated/_general/orders/export': typeof AuthenticatedGeneralOrdersExportRoute
  '/_authenticated/_general/product-categories/$categoryUuid': typeof AuthenticatedGeneralProductCategoriesCategoryUuidRouteWithChildren
  '/_authenticated/_general/product-categories/create': typeof AuthenticatedGeneralProductCategoriesCreateRoute
  '/_authenticated/_general/product-groups/$groupUuid': typeof AuthenticatedGeneralProductGroupsGroupUuidRouteWithChildren
  '/_authenticated/_general/product-groups/create': typeof AuthenticatedGeneralProductGroupsCreateRoute
  '/_authenticated/_general/products/$productUuid': typeof AuthenticatedGeneralProductsProductUuidRouteWithChildren
  '/_authenticated/_general/products/create': typeof AuthenticatedGeneralProductsCreateRoute
  '/_authenticated/_general/products/import': typeof AuthenticatedGeneralProductsImportRoute
  '/_authenticated/_general/products/library': typeof AuthenticatedGeneralProductsLibraryRoute
  '/_authenticated/_general/promotions/$promotionUuid': typeof AuthenticatedGeneralPromotionsPromotionUuidRouteWithChildren
  '/_authenticated/_general/promotions/create': typeof AuthenticatedGeneralPromotionsCreateRoute
  '/_authenticated/settings/integrations/$provider': typeof AuthenticatedSettingsIntegrationsProviderRoute
  '/_authenticated/settings/point-of-sale/$pointOfSaleUuid': typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteWithChildren
  '/_authenticated/settings/point-of-sale/create': typeof AuthenticatedSettingsPointOfSaleCreateRoute
  '/_authenticated/settings/points-of-sale/$pointOfSaleUuid': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteWithChildren
  '/_authenticated/settings/points-of-sale/create': typeof AuthenticatedSettingsPointsOfSaleCreateRoute
  '/_authenticated/settings/profile/edit': typeof AuthenticatedSettingsProfileEditRoute
  '/_authenticated/settings/sales-channels/$salesChannelUuid': typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteWithChildren
  '/_authenticated/settings/sales-channels/create': typeof AuthenticatedSettingsSalesChannelsCreateRoute
  '/_authenticated/settings/users/$userUuid': typeof AuthenticatedSettingsUsersUserUuidRouteWithChildren
  '/_authenticated/settings/users/invite': typeof AuthenticatedSettingsUsersInviteRoute
  '/_authenticated/_general/analytics/': typeof AuthenticatedGeneralAnalyticsIndexRoute
  '/_authenticated/_general/business-cards/': typeof AuthenticatedGeneralBusinessCardsIndexRoute
  '/_authenticated/_general/gift-cards/': typeof AuthenticatedGeneralGiftCardsIndexRoute
  '/_authenticated/_general/loyalty-cards/': typeof AuthenticatedGeneralLoyaltyCardsIndexRoute
  '/_authenticated/_general/marketing/': typeof AuthenticatedGeneralMarketingIndexRoute
  '/_authenticated/_general/orders/': typeof AuthenticatedGeneralOrdersIndexRoute
  '/_authenticated/settings/access-keys/': typeof AuthenticatedSettingsAccessKeysIndexRoute
  '/_authenticated/settings/billing/': typeof AuthenticatedSettingsBillingIndexRoute
  '/_authenticated/settings/exports/': typeof AuthenticatedSettingsExportsIndexRoute
  '/_authenticated/settings/integrations/': typeof AuthenticatedSettingsIntegrationsIndexRoute
  '/_authenticated/settings/marketing-channels/': typeof AuthenticatedSettingsMarketingChannelsIndexRoute
  '/_authenticated/settings/profile/': typeof AuthenticatedSettingsProfileIndexRoute
  '/_authenticated/_general/business-cards/$cardUuid/edit': typeof AuthenticatedGeneralBusinessCardsCardUuidEditRoute
  '/_authenticated/_general/companies/$companyUuid/edit': typeof AuthenticatedGeneralCompaniesCompanyUuidEditRoute
  '/_authenticated/_general/customers/$customerUuid/edit': typeof AuthenticatedGeneralCustomersCustomerUuidEditRoute
  '/_authenticated/_general/gift-cards/$giftCardUuid/edit': typeof AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute
  '/_authenticated/_general/inventory/$inventoryLevelUuid/adjust': typeof AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute
  '/_authenticated/_general/inventory/$inventoryLevelUuid/suppliers': typeof AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute
  '/_authenticated/_general/inventory/receiving/$purchaseOrderUuid': typeof AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute
  '/_authenticated/_general/inventory/receiving/create': typeof AuthenticatedGeneralInventoryReceivingCreateRoute
  '/_authenticated/_general/inventory/suppliers/create': typeof AuthenticatedGeneralInventorySuppliersCreateRoute
  '/_authenticated/_general/inventory/transfers/$transferUuid': typeof AuthenticatedGeneralInventoryTransfersTransferUuidRoute
  '/_authenticated/_general/inventory/transfers/create': typeof AuthenticatedGeneralInventoryTransfersCreateRoute
  '/_authenticated/_general/loyalty-cards/$cardUuid/edit': typeof AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute
  '/_authenticated/_general/marketing/content/$contentUuid': typeof AuthenticatedGeneralMarketingContentContentUuidRoute
  '/_authenticated/_general/marketing/layout/$marketingChannelUuid': typeof AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute
  '/_authenticated/_general/orders/$orderUuid/receipt': typeof AuthenticatedGeneralOrdersOrderUuidReceiptRoute
  '/_authenticated/_general/orders/$orderUuid/refund': typeof AuthenticatedGeneralOrdersOrderUuidRefundRoute
  '/_authenticated/_general/product-categories/$categoryUuid/edit': typeof AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute
  '/_authenticated/_general/product-groups/$groupUuid/edit': typeof AuthenticatedGeneralProductGroupsGroupUuidEditRoute
  '/_authenticated/_general/products/$productUuid/edit': typeof AuthenticatedGeneralProductsProductUuidEditRoute
  '/_authenticated/_general/products/$productUuid/media': typeof AuthenticatedGeneralProductsProductUuidMediaRoute
  '/_authenticated/_general/products/$productUuid/organization': typeof AuthenticatedGeneralProductsProductUuidOrganizationRoute
  '/_authenticated/_general/products/$productUuid/prices': typeof AuthenticatedGeneralProductsProductUuidPricesRoute
  '/_authenticated/_general/products/gift-cards/create': typeof AuthenticatedGeneralProductsGiftCardsCreateRoute
  '/_authenticated/_general/promotions/$promotionUuid/edit': typeof AuthenticatedGeneralPromotionsPromotionUuidEditRoute
  '/_authenticated/settings/inventory/locations/create': typeof AuthenticatedSettingsInventoryLocationsCreateRoute
  '/_authenticated/settings/point-of-sale/$pointOfSaleUuid/edit': typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute
  '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/edit': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute
  '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/product-menu': typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute
  '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid': typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteWithChildren
  '/_authenticated/settings/points-of-sale/groups/$groupUuid': typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteWithChildren
  '/_authenticated/settings/points-of-sale/groups/create': typeof AuthenticatedSettingsPointsOfSaleGroupsCreateRoute
  '/_authenticated/settings/sales-channels/$salesChannelUuid/edit': typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute
  '/_authenticated/settings/sales-channels/groups/$groupUuid': typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteWithChildren
  '/_authenticated/settings/sales-channels/groups/create': typeof AuthenticatedSettingsSalesChannelsGroupsCreateRoute
  '/_authenticated/settings/sales-channels/types/create': typeof AuthenticatedSettingsSalesChannelsTypesCreateRoute
  '/_authenticated/settings/users/$userUuid/edit': typeof AuthenticatedSettingsUsersUserUuidEditRoute
  '/_authenticated/settings/users/$userUuid/edit-sign-in-credentials': typeof AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute
  '/_authenticated/_general/analytics/reports/': typeof AuthenticatedGeneralAnalyticsReportsIndexRoute
  '/_authenticated/_general/marketing/content/': typeof AuthenticatedGeneralMarketingContentIndexRoute
  '/_authenticated/_general/marketing/layout/': typeof AuthenticatedGeneralMarketingLayoutIndexRoute
  '/_authenticated/settings/points-of-sale/devices/': typeof AuthenticatedSettingsPointsOfSaleDevicesIndexRoute
  '/_authenticated/_general/companies/$companyUuid/settlements/create': typeof AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute
  '/_authenticated/_general/inventory/suppliers/$supplierUuid/edit': typeof AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute
  '/_authenticated/_general/product-groups/$groupUuid/fees/create': typeof AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute
  '/_authenticated/_general/product-groups/$groupUuid/products/add': typeof AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute
  '/_authenticated/settings/inventory/locations/$inventoryLocationUuid/edit': typeof AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute
  '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin': typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute
  '/_authenticated/settings/points-of-sale/groups/$groupUuid/edit': typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute
  '/_authenticated/settings/sales-channels/groups/$groupUuid/edit': typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute
  '/_authenticated/_general/product-groups/$groupUuid/fees/$feeUuid/edit': typeof AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$splat'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/analytics'
    | '/companies'
    | '/customers'
    | '/inventory'
    | '/marketing'
    | '/orders'
    | '/product-categories'
    | '/product-groups'
    | '/products'
    | '/promotions'
    | '/settings/exports'
    | '/settings/integrations'
    | '/settings/inventory'
    | '/settings/marketing-channels'
    | '/settings/point-of-sale'
    | '/settings/points-of-sale'
    | '/settings/profile'
    | '/settings/sales-channels'
    | '/settings/users'
    | '/settings/'
    | '/analytics/reports'
    | '/inventory/receiving'
    | '/inventory/suppliers'
    | '/inventory/transfers'
    | '/products/gift-cards'
    | '/settings/points-of-sale/devices'
    | '/settings/points-of-sale/groups'
    | '/settings/sales-channels/groups'
    | '/settings/sales-channels/types'
    | '/business-cards/$cardUuid'
    | '/companies/$companyUuid'
    | '/companies/create'
    | '/customers/$customerUuid'
    | '/customers/create'
    | '/gift-cards/$giftCardUuid'
    | '/inventory/movements'
    | '/inventory/reports'
    | '/loyalty-cards/$cardUuid'
    | '/marketing/channels'
    | '/marketing/journeys'
    | '/marketing/library'
    | '/marketing/messaging'
    | '/orders/$orderUuid'
    | '/orders/bag-checks'
    | '/orders/export'
    | '/product-categories/$categoryUuid'
    | '/product-categories/create'
    | '/product-groups/$groupUuid'
    | '/product-groups/create'
    | '/products/$productUuid'
    | '/products/create'
    | '/products/import'
    | '/products/library'
    | '/promotions/$promotionUuid'
    | '/promotions/create'
    | '/settings/integrations/$provider'
    | '/settings/point-of-sale/$pointOfSaleUuid'
    | '/settings/point-of-sale/create'
    | '/settings/points-of-sale/$pointOfSaleUuid'
    | '/settings/points-of-sale/create'
    | '/settings/profile/edit'
    | '/settings/sales-channels/$salesChannelUuid'
    | '/settings/sales-channels/create'
    | '/settings/users/$userUuid'
    | '/settings/users/invite'
    | '/analytics/'
    | '/business-cards'
    | '/gift-cards'
    | '/loyalty-cards'
    | '/marketing/'
    | '/orders/'
    | '/settings/access-keys'
    | '/settings/billing'
    | '/settings/exports/'
    | '/settings/integrations/'
    | '/settings/marketing-channels/'
    | '/settings/profile/'
    | '/business-cards/$cardUuid/edit'
    | '/companies/$companyUuid/edit'
    | '/customers/$customerUuid/edit'
    | '/gift-cards/$giftCardUuid/edit'
    | '/inventory/$inventoryLevelUuid/adjust'
    | '/inventory/$inventoryLevelUuid/suppliers'
    | '/inventory/receiving/$purchaseOrderUuid'
    | '/inventory/receiving/create'
    | '/inventory/suppliers/create'
    | '/inventory/transfers/$transferUuid'
    | '/inventory/transfers/create'
    | '/loyalty-cards/$cardUuid/edit'
    | '/marketing/content/$contentUuid'
    | '/marketing/layout/$marketingChannelUuid'
    | '/orders/$orderUuid/receipt'
    | '/orders/$orderUuid/refund'
    | '/product-categories/$categoryUuid/edit'
    | '/product-groups/$groupUuid/edit'
    | '/products/$productUuid/edit'
    | '/products/$productUuid/media'
    | '/products/$productUuid/organization'
    | '/products/$productUuid/prices'
    | '/products/gift-cards/create'
    | '/promotions/$promotionUuid/edit'
    | '/settings/inventory/locations/create'
    | '/settings/point-of-sale/$pointOfSaleUuid/edit'
    | '/settings/points-of-sale/$pointOfSaleUuid/edit'
    | '/settings/points-of-sale/$pointOfSaleUuid/product-menu'
    | '/settings/points-of-sale/devices/$pointOfSaleUuid'
    | '/settings/points-of-sale/groups/$groupUuid'
    | '/settings/points-of-sale/groups/create'
    | '/settings/sales-channels/$salesChannelUuid/edit'
    | '/settings/sales-channels/groups/$groupUuid'
    | '/settings/sales-channels/groups/create'
    | '/settings/sales-channels/types/create'
    | '/settings/users/$userUuid/edit'
    | '/settings/users/$userUuid/edit-sign-in-credentials'
    | '/analytics/reports/'
    | '/marketing/content'
    | '/marketing/layout'
    | '/settings/points-of-sale/devices/'
    | '/companies/$companyUuid/settlements/create'
    | '/inventory/suppliers/$supplierUuid/edit'
    | '/product-groups/$groupUuid/fees/create'
    | '/product-groups/$groupUuid/products/add'
    | '/settings/inventory/locations/$inventoryLocationUuid/edit'
    | '/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin'
    | '/settings/points-of-sale/groups/$groupUuid/edit'
    | '/settings/sales-channels/groups/$groupUuid/edit'
    | '/product-groups/$groupUuid/fees/$feeUuid/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$splat'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/companies'
    | '/customers'
    | '/inventory'
    | '/product-categories'
    | '/product-groups'
    | '/products'
    | '/promotions'
    | '/settings/inventory'
    | '/settings/point-of-sale'
    | '/settings/points-of-sale'
    | '/settings/sales-channels'
    | '/settings/users'
    | '/settings'
    | '/inventory/receiving'
    | '/inventory/suppliers'
    | '/inventory/transfers'
    | '/products/gift-cards'
    | '/settings/points-of-sale/groups'
    | '/settings/sales-channels/groups'
    | '/settings/sales-channels/types'
    | '/business-cards/$cardUuid'
    | '/companies/$companyUuid'
    | '/companies/create'
    | '/customers/$customerUuid'
    | '/customers/create'
    | '/gift-cards/$giftCardUuid'
    | '/inventory/movements'
    | '/inventory/reports'
    | '/loyalty-cards/$cardUuid'
    | '/marketing/channels'
    | '/marketing/journeys'
    | '/marketing/library'
    | '/marketing/messaging'
    | '/orders/$orderUuid'
    | '/orders/bag-checks'
    | '/orders/export'
    | '/product-categories/$categoryUuid'
    | '/product-categories/create'
    | '/product-groups/$groupUuid'
    | '/product-groups/create'
    | '/products/$productUuid'
    | '/products/create'
    | '/products/import'
    | '/products/library'
    | '/promotions/$promotionUuid'
    | '/promotions/create'
    | '/settings/integrations/$provider'
    | '/settings/point-of-sale/$pointOfSaleUuid'
    | '/settings/point-of-sale/create'
    | '/settings/points-of-sale/$pointOfSaleUuid'
    | '/settings/points-of-sale/create'
    | '/settings/profile/edit'
    | '/settings/sales-channels/$salesChannelUuid'
    | '/settings/sales-channels/create'
    | '/settings/users/$userUuid'
    | '/settings/users/invite'
    | '/analytics'
    | '/business-cards'
    | '/gift-cards'
    | '/loyalty-cards'
    | '/marketing'
    | '/orders'
    | '/settings/access-keys'
    | '/settings/billing'
    | '/settings/exports'
    | '/settings/integrations'
    | '/settings/marketing-channels'
    | '/settings/profile'
    | '/business-cards/$cardUuid/edit'
    | '/companies/$companyUuid/edit'
    | '/customers/$customerUuid/edit'
    | '/gift-cards/$giftCardUuid/edit'
    | '/inventory/$inventoryLevelUuid/adjust'
    | '/inventory/$inventoryLevelUuid/suppliers'
    | '/inventory/receiving/$purchaseOrderUuid'
    | '/inventory/receiving/create'
    | '/inventory/suppliers/create'
    | '/inventory/transfers/$transferUuid'
    | '/inventory/transfers/create'
    | '/loyalty-cards/$cardUuid/edit'
    | '/marketing/content/$contentUuid'
    | '/marketing/layout/$marketingChannelUuid'
    | '/orders/$orderUuid/receipt'
    | '/orders/$orderUuid/refund'
    | '/product-categories/$categoryUuid/edit'
    | '/product-groups/$groupUuid/edit'
    | '/products/$productUuid/edit'
    | '/products/$productUuid/media'
    | '/products/$productUuid/organization'
    | '/products/$productUuid/prices'
    | '/products/gift-cards/create'
    | '/promotions/$promotionUuid/edit'
    | '/settings/inventory/locations/create'
    | '/settings/point-of-sale/$pointOfSaleUuid/edit'
    | '/settings/points-of-sale/$pointOfSaleUuid/edit'
    | '/settings/points-of-sale/$pointOfSaleUuid/product-menu'
    | '/settings/points-of-sale/devices/$pointOfSaleUuid'
    | '/settings/points-of-sale/groups/$groupUuid'
    | '/settings/points-of-sale/groups/create'
    | '/settings/sales-channels/$salesChannelUuid/edit'
    | '/settings/sales-channels/groups/$groupUuid'
    | '/settings/sales-channels/groups/create'
    | '/settings/sales-channels/types/create'
    | '/settings/users/$userUuid/edit'
    | '/settings/users/$userUuid/edit-sign-in-credentials'
    | '/analytics/reports'
    | '/marketing/content'
    | '/marketing/layout'
    | '/settings/points-of-sale/devices'
    | '/companies/$companyUuid/settlements/create'
    | '/inventory/suppliers/$supplierUuid/edit'
    | '/product-groups/$groupUuid/fees/create'
    | '/product-groups/$groupUuid/products/add'
    | '/settings/inventory/locations/$inventoryLocationUuid/edit'
    | '/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin'
    | '/settings/points-of-sale/groups/$groupUuid/edit'
    | '/settings/sales-channels/groups/$groupUuid/edit'
    | '/product-groups/$groupUuid/fees/$feeUuid/edit'
  id:
    | '__root__'
    | '/'
    | '/$splat'
    | '/_authenticated'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/_authenticated/_general'
    | '/_authenticated/settings'
    | '/_authenticated/_general/analytics'
    | '/_authenticated/_general/companies'
    | '/_authenticated/_general/customers'
    | '/_authenticated/_general/inventory'
    | '/_authenticated/_general/marketing'
    | '/_authenticated/_general/orders'
    | '/_authenticated/_general/product-categories'
    | '/_authenticated/_general/product-groups'
    | '/_authenticated/_general/products'
    | '/_authenticated/_general/promotions'
    | '/_authenticated/settings/exports'
    | '/_authenticated/settings/integrations'
    | '/_authenticated/settings/inventory'
    | '/_authenticated/settings/marketing-channels'
    | '/_authenticated/settings/point-of-sale'
    | '/_authenticated/settings/points-of-sale'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/sales-channels'
    | '/_authenticated/settings/users'
    | '/_authenticated/settings/'
    | '/_authenticated/_general/analytics/reports'
    | '/_authenticated/_general/inventory/receiving'
    | '/_authenticated/_general/inventory/suppliers'
    | '/_authenticated/_general/inventory/transfers'
    | '/_authenticated/_general/products/gift-cards'
    | '/_authenticated/settings/points-of-sale/devices'
    | '/_authenticated/settings/points-of-sale/groups'
    | '/_authenticated/settings/sales-channels/groups'
    | '/_authenticated/settings/sales-channels/types'
    | '/_authenticated/_general/business-cards/$cardUuid'
    | '/_authenticated/_general/companies/$companyUuid'
    | '/_authenticated/_general/companies/create'
    | '/_authenticated/_general/customers/$customerUuid'
    | '/_authenticated/_general/customers/create'
    | '/_authenticated/_general/gift-cards/$giftCardUuid'
    | '/_authenticated/_general/inventory/movements'
    | '/_authenticated/_general/inventory/reports'
    | '/_authenticated/_general/loyalty-cards/$cardUuid'
    | '/_authenticated/_general/marketing/channels'
    | '/_authenticated/_general/marketing/journeys'
    | '/_authenticated/_general/marketing/library'
    | '/_authenticated/_general/marketing/messaging'
    | '/_authenticated/_general/orders/$orderUuid'
    | '/_authenticated/_general/orders/bag-checks'
    | '/_authenticated/_general/orders/export'
    | '/_authenticated/_general/product-categories/$categoryUuid'
    | '/_authenticated/_general/product-categories/create'
    | '/_authenticated/_general/product-groups/$groupUuid'
    | '/_authenticated/_general/product-groups/create'
    | '/_authenticated/_general/products/$productUuid'
    | '/_authenticated/_general/products/create'
    | '/_authenticated/_general/products/import'
    | '/_authenticated/_general/products/library'
    | '/_authenticated/_general/promotions/$promotionUuid'
    | '/_authenticated/_general/promotions/create'
    | '/_authenticated/settings/integrations/$provider'
    | '/_authenticated/settings/point-of-sale/$pointOfSaleUuid'
    | '/_authenticated/settings/point-of-sale/create'
    | '/_authenticated/settings/points-of-sale/$pointOfSaleUuid'
    | '/_authenticated/settings/points-of-sale/create'
    | '/_authenticated/settings/profile/edit'
    | '/_authenticated/settings/sales-channels/$salesChannelUuid'
    | '/_authenticated/settings/sales-channels/create'
    | '/_authenticated/settings/users/$userUuid'
    | '/_authenticated/settings/users/invite'
    | '/_authenticated/_general/analytics/'
    | '/_authenticated/_general/business-cards/'
    | '/_authenticated/_general/gift-cards/'
    | '/_authenticated/_general/loyalty-cards/'
    | '/_authenticated/_general/marketing/'
    | '/_authenticated/_general/orders/'
    | '/_authenticated/settings/access-keys/'
    | '/_authenticated/settings/billing/'
    | '/_authenticated/settings/exports/'
    | '/_authenticated/settings/integrations/'
    | '/_authenticated/settings/marketing-channels/'
    | '/_authenticated/settings/profile/'
    | '/_authenticated/_general/business-cards/$cardUuid/edit'
    | '/_authenticated/_general/companies/$companyUuid/edit'
    | '/_authenticated/_general/customers/$customerUuid/edit'
    | '/_authenticated/_general/gift-cards/$giftCardUuid/edit'
    | '/_authenticated/_general/inventory/$inventoryLevelUuid/adjust'
    | '/_authenticated/_general/inventory/$inventoryLevelUuid/suppliers'
    | '/_authenticated/_general/inventory/receiving/$purchaseOrderUuid'
    | '/_authenticated/_general/inventory/receiving/create'
    | '/_authenticated/_general/inventory/suppliers/create'
    | '/_authenticated/_general/inventory/transfers/$transferUuid'
    | '/_authenticated/_general/inventory/transfers/create'
    | '/_authenticated/_general/loyalty-cards/$cardUuid/edit'
    | '/_authenticated/_general/marketing/content/$contentUuid'
    | '/_authenticated/_general/marketing/layout/$marketingChannelUuid'
    | '/_authenticated/_general/orders/$orderUuid/receipt'
    | '/_authenticated/_general/orders/$orderUuid/refund'
    | '/_authenticated/_general/product-categories/$categoryUuid/edit'
    | '/_authenticated/_general/product-groups/$groupUuid/edit'
    | '/_authenticated/_general/products/$productUuid/edit'
    | '/_authenticated/_general/products/$productUuid/media'
    | '/_authenticated/_general/products/$productUuid/organization'
    | '/_authenticated/_general/products/$productUuid/prices'
    | '/_authenticated/_general/products/gift-cards/create'
    | '/_authenticated/_general/promotions/$promotionUuid/edit'
    | '/_authenticated/settings/inventory/locations/create'
    | '/_authenticated/settings/point-of-sale/$pointOfSaleUuid/edit'
    | '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/edit'
    | '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/product-menu'
    | '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid'
    | '/_authenticated/settings/points-of-sale/groups/$groupUuid'
    | '/_authenticated/settings/points-of-sale/groups/create'
    | '/_authenticated/settings/sales-channels/$salesChannelUuid/edit'
    | '/_authenticated/settings/sales-channels/groups/$groupUuid'
    | '/_authenticated/settings/sales-channels/groups/create'
    | '/_authenticated/settings/sales-channels/types/create'
    | '/_authenticated/settings/users/$userUuid/edit'
    | '/_authenticated/settings/users/$userUuid/edit-sign-in-credentials'
    | '/_authenticated/_general/analytics/reports/'
    | '/_authenticated/_general/marketing/content/'
    | '/_authenticated/_general/marketing/layout/'
    | '/_authenticated/settings/points-of-sale/devices/'
    | '/_authenticated/_general/companies/$companyUuid/settlements/create'
    | '/_authenticated/_general/inventory/suppliers/$supplierUuid/edit'
    | '/_authenticated/_general/product-groups/$groupUuid/fees/create'
    | '/_authenticated/_general/product-groups/$groupUuid/products/add'
    | '/_authenticated/settings/inventory/locations/$inventoryLocationUuid/edit'
    | '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin'
    | '/_authenticated/settings/points-of-sale/groups/$groupUuid/edit'
    | '/_authenticated/settings/sales-channels/groups/$groupUuid/edit'
    | '/_authenticated/_general/product-groups/$groupUuid/fees/$feeUuid/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$splat': {
      id: '/$splat'
      path: '/$splat'
      fullPath: '/$splat'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_general': {
      id: '/_authenticated/_general'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedGeneralRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/sales-channels': {
      id: '/_authenticated/settings/sales-channels'
      path: '/sales-channels'
      fullPath: '/settings/sales-channels'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/points-of-sale': {
      id: '/_authenticated/settings/points-of-sale'
      path: '/points-of-sale'
      fullPath: '/settings/points-of-sale'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/point-of-sale': {
      id: '/_authenticated/settings/point-of-sale'
      path: '/point-of-sale'
      fullPath: '/settings/point-of-sale'
      preLoaderRoute: typeof AuthenticatedSettingsPointOfSaleRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/marketing-channels': {
      id: '/_authenticated/settings/marketing-channels'
      path: '/marketing-channels'
      fullPath: '/settings/marketing-channels'
      preLoaderRoute: typeof AuthenticatedSettingsMarketingChannelsRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/inventory': {
      id: '/_authenticated/settings/inventory'
      path: '/inventory'
      fullPath: '/settings/inventory'
      preLoaderRoute: typeof AuthenticatedSettingsInventoryRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/integrations': {
      id: '/_authenticated/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/exports': {
      id: '/_authenticated/settings/exports'
      path: '/exports'
      fullPath: '/settings/exports'
      preLoaderRoute: typeof AuthenticatedSettingsExportsRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/_general/promotions': {
      id: '/_authenticated/_general/promotions'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof AuthenticatedGeneralPromotionsRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/products': {
      id: '/_authenticated/_general/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedGeneralProductsRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/product-groups': {
      id: '/_authenticated/_general/product-groups'
      path: '/product-groups'
      fullPath: '/product-groups'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/product-categories': {
      id: '/_authenticated/_general/product-categories'
      path: '/product-categories'
      fullPath: '/product-categories'
      preLoaderRoute: typeof AuthenticatedGeneralProductCategoriesRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/orders': {
      id: '/_authenticated/_general/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/marketing': {
      id: '/_authenticated/_general/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/inventory': {
      id: '/_authenticated/_general/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/customers': {
      id: '/_authenticated/_general/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedGeneralCustomersRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/companies': {
      id: '/_authenticated/_general/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedGeneralCompaniesRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/analytics': {
      id: '/_authenticated/_general/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedGeneralAnalyticsRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/settings/profile/': {
      id: '/_authenticated/settings/profile/'
      path: '/'
      fullPath: '/settings/profile/'
      preLoaderRoute: typeof AuthenticatedSettingsProfileIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsProfileRouteRoute
    }
    '/_authenticated/settings/marketing-channels/': {
      id: '/_authenticated/settings/marketing-channels/'
      path: '/'
      fullPath: '/settings/marketing-channels/'
      preLoaderRoute: typeof AuthenticatedSettingsMarketingChannelsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsMarketingChannelsRouteRoute
    }
    '/_authenticated/settings/integrations/': {
      id: '/_authenticated/settings/integrations/'
      path: '/'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsIntegrationsRouteRoute
    }
    '/_authenticated/settings/exports/': {
      id: '/_authenticated/settings/exports/'
      path: '/'
      fullPath: '/settings/exports/'
      preLoaderRoute: typeof AuthenticatedSettingsExportsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsExportsRouteRoute
    }
    '/_authenticated/settings/billing/': {
      id: '/_authenticated/settings/billing/'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/access-keys/': {
      id: '/_authenticated/settings/access-keys/'
      path: '/access-keys'
      fullPath: '/settings/access-keys'
      preLoaderRoute: typeof AuthenticatedSettingsAccessKeysIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/_general/orders/': {
      id: '/_authenticated/_general/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralOrdersRouteRoute
    }
    '/_authenticated/_general/marketing/': {
      id: '/_authenticated/_general/marketing/'
      path: '/'
      fullPath: '/marketing/'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/loyalty-cards/': {
      id: '/_authenticated/_general/loyalty-cards/'
      path: '/loyalty-cards'
      fullPath: '/loyalty-cards'
      preLoaderRoute: typeof AuthenticatedGeneralLoyaltyCardsIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/gift-cards/': {
      id: '/_authenticated/_general/gift-cards/'
      path: '/gift-cards'
      fullPath: '/gift-cards'
      preLoaderRoute: typeof AuthenticatedGeneralGiftCardsIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/business-cards/': {
      id: '/_authenticated/_general/business-cards/'
      path: '/business-cards'
      fullPath: '/business-cards'
      preLoaderRoute: typeof AuthenticatedGeneralBusinessCardsIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/analytics/': {
      id: '/_authenticated/_general/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedGeneralAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralAnalyticsRouteRoute
    }
    '/_authenticated/settings/users/invite': {
      id: '/_authenticated/settings/users/invite'
      path: '/invite'
      fullPath: '/settings/users/invite'
      preLoaderRoute: typeof AuthenticatedSettingsUsersInviteRouteImport
      parentRoute: typeof AuthenticatedSettingsUsersRouteRoute
    }
    '/_authenticated/settings/users/$userUuid': {
      id: '/_authenticated/settings/users/$userUuid'
      path: '/$userUuid'
      fullPath: '/settings/users/$userUuid'
      preLoaderRoute: typeof AuthenticatedSettingsUsersUserUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsUsersRouteRoute
    }
    '/_authenticated/settings/sales-channels/create': {
      id: '/_authenticated/settings/sales-channels/create'
      path: '/create'
      fullPath: '/settings/sales-channels/create'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsRouteRoute
    }
    '/_authenticated/settings/sales-channels/$salesChannelUuid': {
      id: '/_authenticated/settings/sales-channels/$salesChannelUuid'
      path: '/$salesChannelUuid'
      fullPath: '/settings/sales-channels/$salesChannelUuid'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsRouteRoute
    }
    '/_authenticated/settings/profile/edit': {
      id: '/_authenticated/settings/profile/edit'
      path: '/edit'
      fullPath: '/settings/profile/edit'
      preLoaderRoute: typeof AuthenticatedSettingsProfileEditRouteImport
      parentRoute: typeof AuthenticatedSettingsProfileRouteRoute
    }
    '/_authenticated/settings/points-of-sale/create': {
      id: '/_authenticated/settings/points-of-sale/create'
      path: '/create'
      fullPath: '/settings/points-of-sale/create'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleRouteRoute
    }
    '/_authenticated/settings/points-of-sale/$pointOfSaleUuid': {
      id: '/_authenticated/settings/points-of-sale/$pointOfSaleUuid'
      path: '/$pointOfSaleUuid'
      fullPath: '/settings/points-of-sale/$pointOfSaleUuid'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleRouteRoute
    }
    '/_authenticated/settings/point-of-sale/create': {
      id: '/_authenticated/settings/point-of-sale/create'
      path: '/create'
      fullPath: '/settings/point-of-sale/create'
      preLoaderRoute: typeof AuthenticatedSettingsPointOfSaleCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsPointOfSaleRouteRoute
    }
    '/_authenticated/settings/point-of-sale/$pointOfSaleUuid': {
      id: '/_authenticated/settings/point-of-sale/$pointOfSaleUuid'
      path: '/$pointOfSaleUuid'
      fullPath: '/settings/point-of-sale/$pointOfSaleUuid'
      preLoaderRoute: typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsPointOfSaleRouteRoute
    }
    '/_authenticated/settings/integrations/$provider': {
      id: '/_authenticated/settings/integrations/$provider'
      path: '/$provider'
      fullPath: '/settings/integrations/$provider'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsProviderRouteImport
      parentRoute: typeof AuthenticatedSettingsIntegrationsRouteRoute
    }
    '/_authenticated/_general/promotions/create': {
      id: '/_authenticated/_general/promotions/create'
      path: '/create'
      fullPath: '/promotions/create'
      preLoaderRoute: typeof AuthenticatedGeneralPromotionsCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralPromotionsRouteRoute
    }
    '/_authenticated/_general/promotions/$promotionUuid': {
      id: '/_authenticated/_general/promotions/$promotionUuid'
      path: '/$promotionUuid'
      fullPath: '/promotions/$promotionUuid'
      preLoaderRoute: typeof AuthenticatedGeneralPromotionsPromotionUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralPromotionsRouteRoute
    }
    '/_authenticated/_general/products/library': {
      id: '/_authenticated/_general/products/library'
      path: '/library'
      fullPath: '/products/library'
      preLoaderRoute: typeof AuthenticatedGeneralProductsLibraryRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsRouteRoute
    }
    '/_authenticated/_general/products/import': {
      id: '/_authenticated/_general/products/import'
      path: '/import'
      fullPath: '/products/import'
      preLoaderRoute: typeof AuthenticatedGeneralProductsImportRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsRouteRoute
    }
    '/_authenticated/_general/products/create': {
      id: '/_authenticated/_general/products/create'
      path: '/create'
      fullPath: '/products/create'
      preLoaderRoute: typeof AuthenticatedGeneralProductsCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsRouteRoute
    }
    '/_authenticated/_general/products/$productUuid': {
      id: '/_authenticated/_general/products/$productUuid'
      path: '/$productUuid'
      fullPath: '/products/$productUuid'
      preLoaderRoute: typeof AuthenticatedGeneralProductsProductUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsRouteRoute
    }
    '/_authenticated/_general/product-groups/create': {
      id: '/_authenticated/_general/product-groups/create'
      path: '/create'
      fullPath: '/product-groups/create'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralProductGroupsRouteRoute
    }
    '/_authenticated/_general/product-groups/$groupUuid': {
      id: '/_authenticated/_general/product-groups/$groupUuid'
      path: '/$groupUuid'
      fullPath: '/product-groups/$groupUuid'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralProductGroupsRouteRoute
    }
    '/_authenticated/_general/product-categories/create': {
      id: '/_authenticated/_general/product-categories/create'
      path: '/create'
      fullPath: '/product-categories/create'
      preLoaderRoute: typeof AuthenticatedGeneralProductCategoriesCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralProductCategoriesRouteRoute
    }
    '/_authenticated/_general/product-categories/$categoryUuid': {
      id: '/_authenticated/_general/product-categories/$categoryUuid'
      path: '/$categoryUuid'
      fullPath: '/product-categories/$categoryUuid'
      preLoaderRoute: typeof AuthenticatedGeneralProductCategoriesCategoryUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralProductCategoriesRouteRoute
    }
    '/_authenticated/_general/orders/export': {
      id: '/_authenticated/_general/orders/export'
      path: '/export'
      fullPath: '/orders/export'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersExportRouteImport
      parentRoute: typeof AuthenticatedGeneralOrdersRouteRoute
    }
    '/_authenticated/_general/orders/bag-checks': {
      id: '/_authenticated/_general/orders/bag-checks'
      path: '/bag-checks'
      fullPath: '/orders/bag-checks'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersBagChecksRouteImport
      parentRoute: typeof AuthenticatedGeneralOrdersRouteRoute
    }
    '/_authenticated/_general/orders/$orderUuid': {
      id: '/_authenticated/_general/orders/$orderUuid'
      path: '/$orderUuid'
      fullPath: '/orders/$orderUuid'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersOrderUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralOrdersRouteRoute
    }
    '/_authenticated/_general/marketing/messaging': {
      id: '/_authenticated/_general/marketing/messaging'
      path: '/messaging'
      fullPath: '/marketing/messaging'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingMessagingRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/marketing/library': {
      id: '/_authenticated/_general/marketing/library'
      path: '/library'
      fullPath: '/marketing/library'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingLibraryRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/marketing/journeys': {
      id: '/_authenticated/_general/marketing/journeys'
      path: '/journeys'
      fullPath: '/marketing/journeys'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingJourneysRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/marketing/channels': {
      id: '/_authenticated/_general/marketing/channels'
      path: '/channels'
      fullPath: '/marketing/channels'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingChannelsRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/loyalty-cards/$cardUuid': {
      id: '/_authenticated/_general/loyalty-cards/$cardUuid'
      path: '/loyalty-cards/$cardUuid'
      fullPath: '/loyalty-cards/$cardUuid'
      preLoaderRoute: typeof AuthenticatedGeneralLoyaltyCardsCardUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/inventory/reports': {
      id: '/_authenticated/_general/inventory/reports'
      path: '/reports'
      fullPath: '/inventory/reports'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryReportsRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/inventory/movements': {
      id: '/_authenticated/_general/inventory/movements'
      path: '/movements'
      fullPath: '/inventory/movements'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryMovementsRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/gift-cards/$giftCardUuid': {
      id: '/_authenticated/_general/gift-cards/$giftCardUuid'
      path: '/gift-cards/$giftCardUuid'
      fullPath: '/gift-cards/$giftCardUuid'
      preLoaderRoute: typeof AuthenticatedGeneralGiftCardsGiftCardUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/_general/customers/create': {
      id: '/_authenticated/_general/customers/create'
      path: '/create'
      fullPath: '/customers/create'
      preLoaderRoute: typeof AuthenticatedGeneralCustomersCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralCustomersRouteRoute
    }
    '/_authenticated/_general/customers/$customerUuid': {
      id: '/_authenticated/_general/customers/$customerUuid'
      path: '/$customerUuid'
      fullPath: '/customers/$customerUuid'
      preLoaderRoute: typeof AuthenticatedGeneralCustomersCustomerUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralCustomersRouteRoute
    }
    '/_authenticated/_general/companies/create': {
      id: '/_authenticated/_general/companies/create'
      path: '/create'
      fullPath: '/companies/create'
      preLoaderRoute: typeof AuthenticatedGeneralCompaniesCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralCompaniesRouteRoute
    }
    '/_authenticated/_general/companies/$companyUuid': {
      id: '/_authenticated/_general/companies/$companyUuid'
      path: '/$companyUuid'
      fullPath: '/companies/$companyUuid'
      preLoaderRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralCompaniesRouteRoute
    }
    '/_authenticated/_general/business-cards/$cardUuid': {
      id: '/_authenticated/_general/business-cards/$cardUuid'
      path: '/business-cards/$cardUuid'
      fullPath: '/business-cards/$cardUuid'
      preLoaderRoute: typeof AuthenticatedGeneralBusinessCardsCardUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralRouteRoute
    }
    '/_authenticated/settings/sales-channels/types': {
      id: '/_authenticated/settings/sales-channels/types'
      path: '/types'
      fullPath: '/settings/sales-channels/types'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsTypesRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsRouteRoute
    }
    '/_authenticated/settings/sales-channels/groups': {
      id: '/_authenticated/settings/sales-channels/groups'
      path: '/groups'
      fullPath: '/settings/sales-channels/groups'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsGroupsRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsRouteRoute
    }
    '/_authenticated/settings/points-of-sale/groups': {
      id: '/_authenticated/settings/points-of-sale/groups'
      path: '/groups'
      fullPath: '/settings/points-of-sale/groups'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleRouteRoute
    }
    '/_authenticated/settings/points-of-sale/devices': {
      id: '/_authenticated/settings/points-of-sale/devices'
      path: '/devices'
      fullPath: '/settings/points-of-sale/devices'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleRouteRoute
    }
    '/_authenticated/_general/products/gift-cards': {
      id: '/_authenticated/_general/products/gift-cards'
      path: '/gift-cards'
      fullPath: '/products/gift-cards'
      preLoaderRoute: typeof AuthenticatedGeneralProductsGiftCardsRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsRouteRoute
    }
    '/_authenticated/_general/inventory/transfers': {
      id: '/_authenticated/_general/inventory/transfers'
      path: '/transfers'
      fullPath: '/inventory/transfers'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryTransfersRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/inventory/suppliers': {
      id: '/_authenticated/_general/inventory/suppliers'
      path: '/suppliers'
      fullPath: '/inventory/suppliers'
      preLoaderRoute: typeof AuthenticatedGeneralInventorySuppliersRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/inventory/receiving': {
      id: '/_authenticated/_general/inventory/receiving'
      path: '/receiving'
      fullPath: '/inventory/receiving'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryReceivingRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/analytics/reports': {
      id: '/_authenticated/_general/analytics/reports'
      path: '/reports'
      fullPath: '/analytics/reports'
      preLoaderRoute: typeof AuthenticatedGeneralAnalyticsReportsRouteRouteImport
      parentRoute: typeof AuthenticatedGeneralAnalyticsRouteRoute
    }
    '/_authenticated/settings/points-of-sale/devices/': {
      id: '/_authenticated/settings/points-of-sale/devices/'
      path: '/'
      fullPath: '/settings/points-of-sale/devices/'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesRouteRoute
    }
    '/_authenticated/_general/marketing/layout/': {
      id: '/_authenticated/_general/marketing/layout/'
      path: '/layout'
      fullPath: '/marketing/layout'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/marketing/content/': {
      id: '/_authenticated/_general/marketing/content/'
      path: '/content'
      fullPath: '/marketing/content'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingContentIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/analytics/reports/': {
      id: '/_authenticated/_general/analytics/reports/'
      path: '/'
      fullPath: '/analytics/reports/'
      preLoaderRoute: typeof AuthenticatedGeneralAnalyticsReportsIndexRouteImport
      parentRoute: typeof AuthenticatedGeneralAnalyticsReportsRouteRoute
    }
    '/_authenticated/settings/users/$userUuid/edit-sign-in-credentials': {
      id: '/_authenticated/settings/users/$userUuid/edit-sign-in-credentials'
      path: '/edit-sign-in-credentials'
      fullPath: '/settings/users/$userUuid/edit-sign-in-credentials'
      preLoaderRoute: typeof AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRouteImport
      parentRoute: typeof AuthenticatedSettingsUsersUserUuidRoute
    }
    '/_authenticated/settings/users/$userUuid/edit': {
      id: '/_authenticated/settings/users/$userUuid/edit'
      path: '/edit'
      fullPath: '/settings/users/$userUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsUsersUserUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsUsersUserUuidRoute
    }
    '/_authenticated/settings/sales-channels/types/create': {
      id: '/_authenticated/settings/sales-channels/types/create'
      path: '/create'
      fullPath: '/settings/sales-channels/types/create'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsTypesCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsTypesRouteRoute
    }
    '/_authenticated/settings/sales-channels/groups/create': {
      id: '/_authenticated/settings/sales-channels/groups/create'
      path: '/create'
      fullPath: '/settings/sales-channels/groups/create'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsGroupsCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsGroupsRouteRoute
    }
    '/_authenticated/settings/sales-channels/groups/$groupUuid': {
      id: '/_authenticated/settings/sales-channels/groups/$groupUuid'
      path: '/$groupUuid'
      fullPath: '/settings/sales-channels/groups/$groupUuid'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsGroupsRouteRoute
    }
    '/_authenticated/settings/sales-channels/$salesChannelUuid/edit': {
      id: '/_authenticated/settings/sales-channels/$salesChannelUuid/edit'
      path: '/edit'
      fullPath: '/settings/sales-channels/$salesChannelUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidRoute
    }
    '/_authenticated/settings/points-of-sale/groups/create': {
      id: '/_authenticated/settings/points-of-sale/groups/create'
      path: '/create'
      fullPath: '/settings/points-of-sale/groups/create'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRoute
    }
    '/_authenticated/settings/points-of-sale/groups/$groupUuid': {
      id: '/_authenticated/settings/points-of-sale/groups/$groupUuid'
      path: '/$groupUuid'
      fullPath: '/settings/points-of-sale/groups/$groupUuid'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRoute
    }
    '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid': {
      id: '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid'
      path: '/$pointOfSaleUuid'
      fullPath: '/settings/points-of-sale/devices/$pointOfSaleUuid'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesRouteRoute
    }
    '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/product-menu': {
      id: '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/product-menu'
      path: '/product-menu'
      fullPath: '/settings/points-of-sale/$pointOfSaleUuid/product-menu'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute
    }
    '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/edit': {
      id: '/_authenticated/settings/points-of-sale/$pointOfSaleUuid/edit'
      path: '/edit'
      fullPath: '/settings/points-of-sale/$pointOfSaleUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute
    }
    '/_authenticated/settings/point-of-sale/$pointOfSaleUuid/edit': {
      id: '/_authenticated/settings/point-of-sale/$pointOfSaleUuid/edit'
      path: '/edit'
      fullPath: '/settings/point-of-sale/$pointOfSaleUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidRoute
    }
    '/_authenticated/settings/inventory/locations/create': {
      id: '/_authenticated/settings/inventory/locations/create'
      path: '/locations/create'
      fullPath: '/settings/inventory/locations/create'
      preLoaderRoute: typeof AuthenticatedSettingsInventoryLocationsCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsInventoryRouteRoute
    }
    '/_authenticated/_general/promotions/$promotionUuid/edit': {
      id: '/_authenticated/_general/promotions/$promotionUuid/edit'
      path: '/edit'
      fullPath: '/promotions/$promotionUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralPromotionsPromotionUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralPromotionsPromotionUuidRoute
    }
    '/_authenticated/_general/products/gift-cards/create': {
      id: '/_authenticated/_general/products/gift-cards/create'
      path: '/create'
      fullPath: '/products/gift-cards/create'
      preLoaderRoute: typeof AuthenticatedGeneralProductsGiftCardsCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsGiftCardsRouteRoute
    }
    '/_authenticated/_general/products/$productUuid/prices': {
      id: '/_authenticated/_general/products/$productUuid/prices'
      path: '/prices'
      fullPath: '/products/$productUuid/prices'
      preLoaderRoute: typeof AuthenticatedGeneralProductsProductUuidPricesRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsProductUuidRoute
    }
    '/_authenticated/_general/products/$productUuid/organization': {
      id: '/_authenticated/_general/products/$productUuid/organization'
      path: '/organization'
      fullPath: '/products/$productUuid/organization'
      preLoaderRoute: typeof AuthenticatedGeneralProductsProductUuidOrganizationRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsProductUuidRoute
    }
    '/_authenticated/_general/products/$productUuid/media': {
      id: '/_authenticated/_general/products/$productUuid/media'
      path: '/media'
      fullPath: '/products/$productUuid/media'
      preLoaderRoute: typeof AuthenticatedGeneralProductsProductUuidMediaRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsProductUuidRoute
    }
    '/_authenticated/_general/products/$productUuid/edit': {
      id: '/_authenticated/_general/products/$productUuid/edit'
      path: '/edit'
      fullPath: '/products/$productUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralProductsProductUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralProductsProductUuidRoute
    }
    '/_authenticated/_general/product-groups/$groupUuid/edit': {
      id: '/_authenticated/_general/product-groups/$groupUuid/edit'
      path: '/edit'
      fullPath: '/product-groups/$groupUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidRoute
    }
    '/_authenticated/_general/product-categories/$categoryUuid/edit': {
      id: '/_authenticated/_general/product-categories/$categoryUuid/edit'
      path: '/edit'
      fullPath: '/product-categories/$categoryUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralProductCategoriesCategoryUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralProductCategoriesCategoryUuidRoute
    }
    '/_authenticated/_general/orders/$orderUuid/refund': {
      id: '/_authenticated/_general/orders/$orderUuid/refund'
      path: '/refund'
      fullPath: '/orders/$orderUuid/refund'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersOrderUuidRefundRouteImport
      parentRoute: typeof AuthenticatedGeneralOrdersOrderUuidRoute
    }
    '/_authenticated/_general/orders/$orderUuid/receipt': {
      id: '/_authenticated/_general/orders/$orderUuid/receipt'
      path: '/receipt'
      fullPath: '/orders/$orderUuid/receipt'
      preLoaderRoute: typeof AuthenticatedGeneralOrdersOrderUuidReceiptRouteImport
      parentRoute: typeof AuthenticatedGeneralOrdersOrderUuidRoute
    }
    '/_authenticated/_general/marketing/layout/$marketingChannelUuid': {
      id: '/_authenticated/_general/marketing/layout/$marketingChannelUuid'
      path: '/layout/$marketingChannelUuid'
      fullPath: '/marketing/layout/$marketingChannelUuid'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/marketing/content/$contentUuid': {
      id: '/_authenticated/_general/marketing/content/$contentUuid'
      path: '/content/$contentUuid'
      fullPath: '/marketing/content/$contentUuid'
      preLoaderRoute: typeof AuthenticatedGeneralMarketingContentContentUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralMarketingRouteRoute
    }
    '/_authenticated/_general/loyalty-cards/$cardUuid/edit': {
      id: '/_authenticated/_general/loyalty-cards/$cardUuid/edit'
      path: '/edit'
      fullPath: '/loyalty-cards/$cardUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralLoyaltyCardsCardUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralLoyaltyCardsCardUuidRoute
    }
    '/_authenticated/_general/inventory/transfers/create': {
      id: '/_authenticated/_general/inventory/transfers/create'
      path: '/create'
      fullPath: '/inventory/transfers/create'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryTransfersCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryTransfersRouteRoute
    }
    '/_authenticated/_general/inventory/transfers/$transferUuid': {
      id: '/_authenticated/_general/inventory/transfers/$transferUuid'
      path: '/$transferUuid'
      fullPath: '/inventory/transfers/$transferUuid'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryTransfersTransferUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryTransfersRouteRoute
    }
    '/_authenticated/_general/inventory/suppliers/create': {
      id: '/_authenticated/_general/inventory/suppliers/create'
      path: '/create'
      fullPath: '/inventory/suppliers/create'
      preLoaderRoute: typeof AuthenticatedGeneralInventorySuppliersCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralInventorySuppliersRouteRoute
    }
    '/_authenticated/_general/inventory/receiving/create': {
      id: '/_authenticated/_general/inventory/receiving/create'
      path: '/create'
      fullPath: '/inventory/receiving/create'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryReceivingCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryReceivingRouteRoute
    }
    '/_authenticated/_general/inventory/receiving/$purchaseOrderUuid': {
      id: '/_authenticated/_general/inventory/receiving/$purchaseOrderUuid'
      path: '/$purchaseOrderUuid'
      fullPath: '/inventory/receiving/$purchaseOrderUuid'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryReceivingRouteRoute
    }
    '/_authenticated/_general/inventory/$inventoryLevelUuid/suppliers': {
      id: '/_authenticated/_general/inventory/$inventoryLevelUuid/suppliers'
      path: '/$inventoryLevelUuid/suppliers'
      fullPath: '/inventory/$inventoryLevelUuid/suppliers'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/inventory/$inventoryLevelUuid/adjust': {
      id: '/_authenticated/_general/inventory/$inventoryLevelUuid/adjust'
      path: '/$inventoryLevelUuid/adjust'
      fullPath: '/inventory/$inventoryLevelUuid/adjust'
      preLoaderRoute: typeof AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRouteImport
      parentRoute: typeof AuthenticatedGeneralInventoryRouteRoute
    }
    '/_authenticated/_general/gift-cards/$giftCardUuid/edit': {
      id: '/_authenticated/_general/gift-cards/$giftCardUuid/edit'
      path: '/edit'
      fullPath: '/gift-cards/$giftCardUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralGiftCardsGiftCardUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralGiftCardsGiftCardUuidRoute
    }
    '/_authenticated/_general/customers/$customerUuid/edit': {
      id: '/_authenticated/_general/customers/$customerUuid/edit'
      path: '/edit'
      fullPath: '/customers/$customerUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralCustomersCustomerUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralCustomersCustomerUuidRoute
    }
    '/_authenticated/_general/companies/$companyUuid/edit': {
      id: '/_authenticated/_general/companies/$companyUuid/edit'
      path: '/edit'
      fullPath: '/companies/$companyUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidRoute
    }
    '/_authenticated/_general/business-cards/$cardUuid/edit': {
      id: '/_authenticated/_general/business-cards/$cardUuid/edit'
      path: '/edit'
      fullPath: '/business-cards/$cardUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralBusinessCardsCardUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralBusinessCardsCardUuidRoute
    }
    '/_authenticated/settings/sales-channels/groups/$groupUuid/edit': {
      id: '/_authenticated/settings/sales-channels/groups/$groupUuid/edit'
      path: '/edit'
      fullPath: '/settings/sales-channels/groups/$groupUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidRoute
    }
    '/_authenticated/settings/points-of-sale/groups/$groupUuid/edit': {
      id: '/_authenticated/settings/points-of-sale/groups/$groupUuid/edit'
      path: '/edit'
      fullPath: '/settings/points-of-sale/groups/$groupUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRoute
    }
    '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin': {
      id: '/_authenticated/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin'
      path: '/edit-unlock-pin'
      fullPath: '/settings/points-of-sale/devices/$pointOfSaleUuid/edit-unlock-pin'
      preLoaderRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRouteImport
      parentRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRoute
    }
    '/_authenticated/settings/inventory/locations/$inventoryLocationUuid/edit': {
      id: '/_authenticated/settings/inventory/locations/$inventoryLocationUuid/edit'
      path: '/locations/$inventoryLocationUuid/edit'
      fullPath: '/settings/inventory/locations/$inventoryLocationUuid/edit'
      preLoaderRoute: typeof AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRouteImport
      parentRoute: typeof AuthenticatedSettingsInventoryRouteRoute
    }
    '/_authenticated/_general/product-groups/$groupUuid/products/add': {
      id: '/_authenticated/_general/product-groups/$groupUuid/products/add'
      path: '/products/add'
      fullPath: '/product-groups/$groupUuid/products/add'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidProductsAddRouteImport
      parentRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidRoute
    }
    '/_authenticated/_general/product-groups/$groupUuid/fees/create': {
      id: '/_authenticated/_general/product-groups/$groupUuid/fees/create'
      path: '/fees/create'
      fullPath: '/product-groups/$groupUuid/fees/create'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidRoute
    }
    '/_authenticated/_general/inventory/suppliers/$supplierUuid/edit': {
      id: '/_authenticated/_general/inventory/suppliers/$supplierUuid/edit'
      path: '/$supplierUuid/edit'
      fullPath: '/inventory/suppliers/$supplierUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralInventorySuppliersSupplierUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralInventorySuppliersRouteRoute
    }
    '/_authenticated/_general/companies/$companyUuid/settlements/create': {
      id: '/_authenticated/_general/companies/$companyUuid/settlements/create'
      path: '/settlements/create'
      fullPath: '/companies/$companyUuid/settlements/create'
      preLoaderRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRouteImport
      parentRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidRoute
    }
    '/_authenticated/_general/product-groups/$groupUuid/fees/$feeUuid/edit': {
      id: '/_authenticated/_general/product-groups/$groupUuid/fees/$feeUuid/edit'
      path: '/fees/$feeUuid/edit'
      fullPath: '/product-groups/$groupUuid/fees/$feeUuid/edit'
      preLoaderRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRouteImport
      parentRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidRoute
    }
  }
}

interface AuthenticatedGeneralAnalyticsReportsRouteRouteChildren {
  AuthenticatedGeneralAnalyticsReportsIndexRoute: typeof AuthenticatedGeneralAnalyticsReportsIndexRoute
}

const AuthenticatedGeneralAnalyticsReportsRouteRouteChildren: AuthenticatedGeneralAnalyticsReportsRouteRouteChildren =
  {
    AuthenticatedGeneralAnalyticsReportsIndexRoute:
      AuthenticatedGeneralAnalyticsReportsIndexRoute,
  }

const AuthenticatedGeneralAnalyticsReportsRouteRouteWithChildren =
  AuthenticatedGeneralAnalyticsReportsRouteRoute._addFileChildren(
    AuthenticatedGeneralAnalyticsReportsRouteRouteChildren,
  )

interface AuthenticatedGeneralAnalyticsRouteRouteChildren {
  AuthenticatedGeneralAnalyticsReportsRouteRoute: typeof AuthenticatedGeneralAnalyticsReportsRouteRouteWithChildren
  AuthenticatedGeneralAnalyticsIndexRoute: typeof AuthenticatedGeneralAnalyticsIndexRoute
}

const AuthenticatedGeneralAnalyticsRouteRouteChildren: AuthenticatedGeneralAnalyticsRouteRouteChildren =
  {
    AuthenticatedGeneralAnalyticsReportsRouteRoute:
      AuthenticatedGeneralAnalyticsReportsRouteRouteWithChildren,
    AuthenticatedGeneralAnalyticsIndexRoute:
      AuthenticatedGeneralAnalyticsIndexRoute,
  }

const AuthenticatedGeneralAnalyticsRouteRouteWithChildren =
  AuthenticatedGeneralAnalyticsRouteRoute._addFileChildren(
    AuthenticatedGeneralAnalyticsRouteRouteChildren,
  )

interface AuthenticatedGeneralCompaniesCompanyUuidRouteChildren {
  AuthenticatedGeneralCompaniesCompanyUuidEditRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidEditRoute
  AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute
}

const AuthenticatedGeneralCompaniesCompanyUuidRouteChildren: AuthenticatedGeneralCompaniesCompanyUuidRouteChildren =
  {
    AuthenticatedGeneralCompaniesCompanyUuidEditRoute:
      AuthenticatedGeneralCompaniesCompanyUuidEditRoute,
    AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute:
      AuthenticatedGeneralCompaniesCompanyUuidSettlementsCreateRoute,
  }

const AuthenticatedGeneralCompaniesCompanyUuidRouteWithChildren =
  AuthenticatedGeneralCompaniesCompanyUuidRoute._addFileChildren(
    AuthenticatedGeneralCompaniesCompanyUuidRouteChildren,
  )

interface AuthenticatedGeneralCompaniesRouteRouteChildren {
  AuthenticatedGeneralCompaniesCompanyUuidRoute: typeof AuthenticatedGeneralCompaniesCompanyUuidRouteWithChildren
  AuthenticatedGeneralCompaniesCreateRoute: typeof AuthenticatedGeneralCompaniesCreateRoute
}

const AuthenticatedGeneralCompaniesRouteRouteChildren: AuthenticatedGeneralCompaniesRouteRouteChildren =
  {
    AuthenticatedGeneralCompaniesCompanyUuidRoute:
      AuthenticatedGeneralCompaniesCompanyUuidRouteWithChildren,
    AuthenticatedGeneralCompaniesCreateRoute:
      AuthenticatedGeneralCompaniesCreateRoute,
  }

const AuthenticatedGeneralCompaniesRouteRouteWithChildren =
  AuthenticatedGeneralCompaniesRouteRoute._addFileChildren(
    AuthenticatedGeneralCompaniesRouteRouteChildren,
  )

interface AuthenticatedGeneralCustomersCustomerUuidRouteChildren {
  AuthenticatedGeneralCustomersCustomerUuidEditRoute: typeof AuthenticatedGeneralCustomersCustomerUuidEditRoute
}

const AuthenticatedGeneralCustomersCustomerUuidRouteChildren: AuthenticatedGeneralCustomersCustomerUuidRouteChildren =
  {
    AuthenticatedGeneralCustomersCustomerUuidEditRoute:
      AuthenticatedGeneralCustomersCustomerUuidEditRoute,
  }

const AuthenticatedGeneralCustomersCustomerUuidRouteWithChildren =
  AuthenticatedGeneralCustomersCustomerUuidRoute._addFileChildren(
    AuthenticatedGeneralCustomersCustomerUuidRouteChildren,
  )

interface AuthenticatedGeneralCustomersRouteRouteChildren {
  AuthenticatedGeneralCustomersCustomerUuidRoute: typeof AuthenticatedGeneralCustomersCustomerUuidRouteWithChildren
  AuthenticatedGeneralCustomersCreateRoute: typeof AuthenticatedGeneralCustomersCreateRoute
}

const AuthenticatedGeneralCustomersRouteRouteChildren: AuthenticatedGeneralCustomersRouteRouteChildren =
  {
    AuthenticatedGeneralCustomersCustomerUuidRoute:
      AuthenticatedGeneralCustomersCustomerUuidRouteWithChildren,
    AuthenticatedGeneralCustomersCreateRoute:
      AuthenticatedGeneralCustomersCreateRoute,
  }

const AuthenticatedGeneralCustomersRouteRouteWithChildren =
  AuthenticatedGeneralCustomersRouteRoute._addFileChildren(
    AuthenticatedGeneralCustomersRouteRouteChildren,
  )

interface AuthenticatedGeneralInventoryReceivingRouteRouteChildren {
  AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute: typeof AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute
  AuthenticatedGeneralInventoryReceivingCreateRoute: typeof AuthenticatedGeneralInventoryReceivingCreateRoute
}

const AuthenticatedGeneralInventoryReceivingRouteRouteChildren: AuthenticatedGeneralInventoryReceivingRouteRouteChildren =
  {
    AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute:
      AuthenticatedGeneralInventoryReceivingPurchaseOrderUuidRoute,
    AuthenticatedGeneralInventoryReceivingCreateRoute:
      AuthenticatedGeneralInventoryReceivingCreateRoute,
  }

const AuthenticatedGeneralInventoryReceivingRouteRouteWithChildren =
  AuthenticatedGeneralInventoryReceivingRouteRoute._addFileChildren(
    AuthenticatedGeneralInventoryReceivingRouteRouteChildren,
  )

interface AuthenticatedGeneralInventorySuppliersRouteRouteChildren {
  AuthenticatedGeneralInventorySuppliersCreateRoute: typeof AuthenticatedGeneralInventorySuppliersCreateRoute
  AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute: typeof AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute
}

const AuthenticatedGeneralInventorySuppliersRouteRouteChildren: AuthenticatedGeneralInventorySuppliersRouteRouteChildren =
  {
    AuthenticatedGeneralInventorySuppliersCreateRoute:
      AuthenticatedGeneralInventorySuppliersCreateRoute,
    AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute:
      AuthenticatedGeneralInventorySuppliersSupplierUuidEditRoute,
  }

const AuthenticatedGeneralInventorySuppliersRouteRouteWithChildren =
  AuthenticatedGeneralInventorySuppliersRouteRoute._addFileChildren(
    AuthenticatedGeneralInventorySuppliersRouteRouteChildren,
  )

interface AuthenticatedGeneralInventoryTransfersRouteRouteChildren {
  AuthenticatedGeneralInventoryTransfersTransferUuidRoute: typeof AuthenticatedGeneralInventoryTransfersTransferUuidRoute
  AuthenticatedGeneralInventoryTransfersCreateRoute: typeof AuthenticatedGeneralInventoryTransfersCreateRoute
}

const AuthenticatedGeneralInventoryTransfersRouteRouteChildren: AuthenticatedGeneralInventoryTransfersRouteRouteChildren =
  {
    AuthenticatedGeneralInventoryTransfersTransferUuidRoute:
      AuthenticatedGeneralInventoryTransfersTransferUuidRoute,
    AuthenticatedGeneralInventoryTransfersCreateRoute:
      AuthenticatedGeneralInventoryTransfersCreateRoute,
  }

const AuthenticatedGeneralInventoryTransfersRouteRouteWithChildren =
  AuthenticatedGeneralInventoryTransfersRouteRoute._addFileChildren(
    AuthenticatedGeneralInventoryTransfersRouteRouteChildren,
  )

interface AuthenticatedGeneralInventoryRouteRouteChildren {
  AuthenticatedGeneralInventoryReceivingRouteRoute: typeof AuthenticatedGeneralInventoryReceivingRouteRouteWithChildren
  AuthenticatedGeneralInventorySuppliersRouteRoute: typeof AuthenticatedGeneralInventorySuppliersRouteRouteWithChildren
  AuthenticatedGeneralInventoryTransfersRouteRoute: typeof AuthenticatedGeneralInventoryTransfersRouteRouteWithChildren
  AuthenticatedGeneralInventoryMovementsRoute: typeof AuthenticatedGeneralInventoryMovementsRoute
  AuthenticatedGeneralInventoryReportsRoute: typeof AuthenticatedGeneralInventoryReportsRoute
  AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute: typeof AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute
  AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute: typeof AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute
}

const AuthenticatedGeneralInventoryRouteRouteChildren: AuthenticatedGeneralInventoryRouteRouteChildren =
  {
    AuthenticatedGeneralInventoryReceivingRouteRoute:
      AuthenticatedGeneralInventoryReceivingRouteRouteWithChildren,
    AuthenticatedGeneralInventorySuppliersRouteRoute:
      AuthenticatedGeneralInventorySuppliersRouteRouteWithChildren,
    AuthenticatedGeneralInventoryTransfersRouteRoute:
      AuthenticatedGeneralInventoryTransfersRouteRouteWithChildren,
    AuthenticatedGeneralInventoryMovementsRoute:
      AuthenticatedGeneralInventoryMovementsRoute,
    AuthenticatedGeneralInventoryReportsRoute:
      AuthenticatedGeneralInventoryReportsRoute,
    AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute:
      AuthenticatedGeneralInventoryInventoryLevelUuidAdjustRoute,
    AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute:
      AuthenticatedGeneralInventoryInventoryLevelUuidSuppliersRoute,
  }

const AuthenticatedGeneralInventoryRouteRouteWithChildren =
  AuthenticatedGeneralInventoryRouteRoute._addFileChildren(
    AuthenticatedGeneralInventoryRouteRouteChildren,
  )

interface AuthenticatedGeneralMarketingRouteRouteChildren {
  AuthenticatedGeneralMarketingChannelsRoute: typeof AuthenticatedGeneralMarketingChannelsRoute
  AuthenticatedGeneralMarketingJourneysRoute: typeof AuthenticatedGeneralMarketingJourneysRoute
  AuthenticatedGeneralMarketingLibraryRoute: typeof AuthenticatedGeneralMarketingLibraryRoute
  AuthenticatedGeneralMarketingMessagingRoute: typeof AuthenticatedGeneralMarketingMessagingRoute
  AuthenticatedGeneralMarketingIndexRoute: typeof AuthenticatedGeneralMarketingIndexRoute
  AuthenticatedGeneralMarketingContentContentUuidRoute: typeof AuthenticatedGeneralMarketingContentContentUuidRoute
  AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute: typeof AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute
  AuthenticatedGeneralMarketingContentIndexRoute: typeof AuthenticatedGeneralMarketingContentIndexRoute
  AuthenticatedGeneralMarketingLayoutIndexRoute: typeof AuthenticatedGeneralMarketingLayoutIndexRoute
}

const AuthenticatedGeneralMarketingRouteRouteChildren: AuthenticatedGeneralMarketingRouteRouteChildren =
  {
    AuthenticatedGeneralMarketingChannelsRoute:
      AuthenticatedGeneralMarketingChannelsRoute,
    AuthenticatedGeneralMarketingJourneysRoute:
      AuthenticatedGeneralMarketingJourneysRoute,
    AuthenticatedGeneralMarketingLibraryRoute:
      AuthenticatedGeneralMarketingLibraryRoute,
    AuthenticatedGeneralMarketingMessagingRoute:
      AuthenticatedGeneralMarketingMessagingRoute,
    AuthenticatedGeneralMarketingIndexRoute:
      AuthenticatedGeneralMarketingIndexRoute,
    AuthenticatedGeneralMarketingContentContentUuidRoute:
      AuthenticatedGeneralMarketingContentContentUuidRoute,
    AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute:
      AuthenticatedGeneralMarketingLayoutMarketingChannelUuidRoute,
    AuthenticatedGeneralMarketingContentIndexRoute:
      AuthenticatedGeneralMarketingContentIndexRoute,
    AuthenticatedGeneralMarketingLayoutIndexRoute:
      AuthenticatedGeneralMarketingLayoutIndexRoute,
  }

const AuthenticatedGeneralMarketingRouteRouteWithChildren =
  AuthenticatedGeneralMarketingRouteRoute._addFileChildren(
    AuthenticatedGeneralMarketingRouteRouteChildren,
  )

interface AuthenticatedGeneralOrdersOrderUuidRouteChildren {
  AuthenticatedGeneralOrdersOrderUuidReceiptRoute: typeof AuthenticatedGeneralOrdersOrderUuidReceiptRoute
  AuthenticatedGeneralOrdersOrderUuidRefundRoute: typeof AuthenticatedGeneralOrdersOrderUuidRefundRoute
}

const AuthenticatedGeneralOrdersOrderUuidRouteChildren: AuthenticatedGeneralOrdersOrderUuidRouteChildren =
  {
    AuthenticatedGeneralOrdersOrderUuidReceiptRoute:
      AuthenticatedGeneralOrdersOrderUuidReceiptRoute,
    AuthenticatedGeneralOrdersOrderUuidRefundRoute:
      AuthenticatedGeneralOrdersOrderUuidRefundRoute,
  }

const AuthenticatedGeneralOrdersOrderUuidRouteWithChildren =
  AuthenticatedGeneralOrdersOrderUuidRoute._addFileChildren(
    AuthenticatedGeneralOrdersOrderUuidRouteChildren,
  )

interface AuthenticatedGeneralOrdersRouteRouteChildren {
  AuthenticatedGeneralOrdersOrderUuidRoute: typeof AuthenticatedGeneralOrdersOrderUuidRouteWithChildren
  AuthenticatedGeneralOrdersBagChecksRoute: typeof AuthenticatedGeneralOrdersBagChecksRoute
  AuthenticatedGeneralOrdersExportRoute: typeof AuthenticatedGeneralOrdersExportRoute
  AuthenticatedGeneralOrdersIndexRoute: typeof AuthenticatedGeneralOrdersIndexRoute
}

const AuthenticatedGeneralOrdersRouteRouteChildren: AuthenticatedGeneralOrdersRouteRouteChildren =
  {
    AuthenticatedGeneralOrdersOrderUuidRoute:
      AuthenticatedGeneralOrdersOrderUuidRouteWithChildren,
    AuthenticatedGeneralOrdersBagChecksRoute:
      AuthenticatedGeneralOrdersBagChecksRoute,
    AuthenticatedGeneralOrdersExportRoute:
      AuthenticatedGeneralOrdersExportRoute,
    AuthenticatedGeneralOrdersIndexRoute: AuthenticatedGeneralOrdersIndexRoute,
  }

const AuthenticatedGeneralOrdersRouteRouteWithChildren =
  AuthenticatedGeneralOrdersRouteRoute._addFileChildren(
    AuthenticatedGeneralOrdersRouteRouteChildren,
  )

interface AuthenticatedGeneralProductCategoriesCategoryUuidRouteChildren {
  AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute: typeof AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute
}

const AuthenticatedGeneralProductCategoriesCategoryUuidRouteChildren: AuthenticatedGeneralProductCategoriesCategoryUuidRouteChildren =
  {
    AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute:
      AuthenticatedGeneralProductCategoriesCategoryUuidEditRoute,
  }

const AuthenticatedGeneralProductCategoriesCategoryUuidRouteWithChildren =
  AuthenticatedGeneralProductCategoriesCategoryUuidRoute._addFileChildren(
    AuthenticatedGeneralProductCategoriesCategoryUuidRouteChildren,
  )

interface AuthenticatedGeneralProductCategoriesRouteRouteChildren {
  AuthenticatedGeneralProductCategoriesCategoryUuidRoute: typeof AuthenticatedGeneralProductCategoriesCategoryUuidRouteWithChildren
  AuthenticatedGeneralProductCategoriesCreateRoute: typeof AuthenticatedGeneralProductCategoriesCreateRoute
}

const AuthenticatedGeneralProductCategoriesRouteRouteChildren: AuthenticatedGeneralProductCategoriesRouteRouteChildren =
  {
    AuthenticatedGeneralProductCategoriesCategoryUuidRoute:
      AuthenticatedGeneralProductCategoriesCategoryUuidRouteWithChildren,
    AuthenticatedGeneralProductCategoriesCreateRoute:
      AuthenticatedGeneralProductCategoriesCreateRoute,
  }

const AuthenticatedGeneralProductCategoriesRouteRouteWithChildren =
  AuthenticatedGeneralProductCategoriesRouteRoute._addFileChildren(
    AuthenticatedGeneralProductCategoriesRouteRouteChildren,
  )

interface AuthenticatedGeneralProductGroupsGroupUuidRouteChildren {
  AuthenticatedGeneralProductGroupsGroupUuidEditRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidEditRoute
  AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute
  AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute
  AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute
}

const AuthenticatedGeneralProductGroupsGroupUuidRouteChildren: AuthenticatedGeneralProductGroupsGroupUuidRouteChildren =
  {
    AuthenticatedGeneralProductGroupsGroupUuidEditRoute:
      AuthenticatedGeneralProductGroupsGroupUuidEditRoute,
    AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute:
      AuthenticatedGeneralProductGroupsGroupUuidFeesCreateRoute,
    AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute:
      AuthenticatedGeneralProductGroupsGroupUuidProductsAddRoute,
    AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute:
      AuthenticatedGeneralProductGroupsGroupUuidFeesFeeUuidEditRoute,
  }

const AuthenticatedGeneralProductGroupsGroupUuidRouteWithChildren =
  AuthenticatedGeneralProductGroupsGroupUuidRoute._addFileChildren(
    AuthenticatedGeneralProductGroupsGroupUuidRouteChildren,
  )

interface AuthenticatedGeneralProductGroupsRouteRouteChildren {
  AuthenticatedGeneralProductGroupsGroupUuidRoute: typeof AuthenticatedGeneralProductGroupsGroupUuidRouteWithChildren
  AuthenticatedGeneralProductGroupsCreateRoute: typeof AuthenticatedGeneralProductGroupsCreateRoute
}

const AuthenticatedGeneralProductGroupsRouteRouteChildren: AuthenticatedGeneralProductGroupsRouteRouteChildren =
  {
    AuthenticatedGeneralProductGroupsGroupUuidRoute:
      AuthenticatedGeneralProductGroupsGroupUuidRouteWithChildren,
    AuthenticatedGeneralProductGroupsCreateRoute:
      AuthenticatedGeneralProductGroupsCreateRoute,
  }

const AuthenticatedGeneralProductGroupsRouteRouteWithChildren =
  AuthenticatedGeneralProductGroupsRouteRoute._addFileChildren(
    AuthenticatedGeneralProductGroupsRouteRouteChildren,
  )

interface AuthenticatedGeneralProductsGiftCardsRouteRouteChildren {
  AuthenticatedGeneralProductsGiftCardsCreateRoute: typeof AuthenticatedGeneralProductsGiftCardsCreateRoute
}

const AuthenticatedGeneralProductsGiftCardsRouteRouteChildren: AuthenticatedGeneralProductsGiftCardsRouteRouteChildren =
  {
    AuthenticatedGeneralProductsGiftCardsCreateRoute:
      AuthenticatedGeneralProductsGiftCardsCreateRoute,
  }

const AuthenticatedGeneralProductsGiftCardsRouteRouteWithChildren =
  AuthenticatedGeneralProductsGiftCardsRouteRoute._addFileChildren(
    AuthenticatedGeneralProductsGiftCardsRouteRouteChildren,
  )

interface AuthenticatedGeneralProductsProductUuidRouteChildren {
  AuthenticatedGeneralProductsProductUuidEditRoute: typeof AuthenticatedGeneralProductsProductUuidEditRoute
  AuthenticatedGeneralProductsProductUuidMediaRoute: typeof AuthenticatedGeneralProductsProductUuidMediaRoute
  AuthenticatedGeneralProductsProductUuidOrganizationRoute: typeof AuthenticatedGeneralProductsProductUuidOrganizationRoute
  AuthenticatedGeneralProductsProductUuidPricesRoute: typeof AuthenticatedGeneralProductsProductUuidPricesRoute
}

const AuthenticatedGeneralProductsProductUuidRouteChildren: AuthenticatedGeneralProductsProductUuidRouteChildren =
  {
    AuthenticatedGeneralProductsProductUuidEditRoute:
      AuthenticatedGeneralProductsProductUuidEditRoute,
    AuthenticatedGeneralProductsProductUuidMediaRoute:
      AuthenticatedGeneralProductsProductUuidMediaRoute,
    AuthenticatedGeneralProductsProductUuidOrganizationRoute:
      AuthenticatedGeneralProductsProductUuidOrganizationRoute,
    AuthenticatedGeneralProductsProductUuidPricesRoute:
      AuthenticatedGeneralProductsProductUuidPricesRoute,
  }

const AuthenticatedGeneralProductsProductUuidRouteWithChildren =
  AuthenticatedGeneralProductsProductUuidRoute._addFileChildren(
    AuthenticatedGeneralProductsProductUuidRouteChildren,
  )

interface AuthenticatedGeneralProductsRouteRouteChildren {
  AuthenticatedGeneralProductsGiftCardsRouteRoute: typeof AuthenticatedGeneralProductsGiftCardsRouteRouteWithChildren
  AuthenticatedGeneralProductsProductUuidRoute: typeof AuthenticatedGeneralProductsProductUuidRouteWithChildren
  AuthenticatedGeneralProductsCreateRoute: typeof AuthenticatedGeneralProductsCreateRoute
  AuthenticatedGeneralProductsImportRoute: typeof AuthenticatedGeneralProductsImportRoute
  AuthenticatedGeneralProductsLibraryRoute: typeof AuthenticatedGeneralProductsLibraryRoute
}

const AuthenticatedGeneralProductsRouteRouteChildren: AuthenticatedGeneralProductsRouteRouteChildren =
  {
    AuthenticatedGeneralProductsGiftCardsRouteRoute:
      AuthenticatedGeneralProductsGiftCardsRouteRouteWithChildren,
    AuthenticatedGeneralProductsProductUuidRoute:
      AuthenticatedGeneralProductsProductUuidRouteWithChildren,
    AuthenticatedGeneralProductsCreateRoute:
      AuthenticatedGeneralProductsCreateRoute,
    AuthenticatedGeneralProductsImportRoute:
      AuthenticatedGeneralProductsImportRoute,
    AuthenticatedGeneralProductsLibraryRoute:
      AuthenticatedGeneralProductsLibraryRoute,
  }

const AuthenticatedGeneralProductsRouteRouteWithChildren =
  AuthenticatedGeneralProductsRouteRoute._addFileChildren(
    AuthenticatedGeneralProductsRouteRouteChildren,
  )

interface AuthenticatedGeneralPromotionsPromotionUuidRouteChildren {
  AuthenticatedGeneralPromotionsPromotionUuidEditRoute: typeof AuthenticatedGeneralPromotionsPromotionUuidEditRoute
}

const AuthenticatedGeneralPromotionsPromotionUuidRouteChildren: AuthenticatedGeneralPromotionsPromotionUuidRouteChildren =
  {
    AuthenticatedGeneralPromotionsPromotionUuidEditRoute:
      AuthenticatedGeneralPromotionsPromotionUuidEditRoute,
  }

const AuthenticatedGeneralPromotionsPromotionUuidRouteWithChildren =
  AuthenticatedGeneralPromotionsPromotionUuidRoute._addFileChildren(
    AuthenticatedGeneralPromotionsPromotionUuidRouteChildren,
  )

interface AuthenticatedGeneralPromotionsRouteRouteChildren {
  AuthenticatedGeneralPromotionsPromotionUuidRoute: typeof AuthenticatedGeneralPromotionsPromotionUuidRouteWithChildren
  AuthenticatedGeneralPromotionsCreateRoute: typeof AuthenticatedGeneralPromotionsCreateRoute
}

const AuthenticatedGeneralPromotionsRouteRouteChildren: AuthenticatedGeneralPromotionsRouteRouteChildren =
  {
    AuthenticatedGeneralPromotionsPromotionUuidRoute:
      AuthenticatedGeneralPromotionsPromotionUuidRouteWithChildren,
    AuthenticatedGeneralPromotionsCreateRoute:
      AuthenticatedGeneralPromotionsCreateRoute,
  }

const AuthenticatedGeneralPromotionsRouteRouteWithChildren =
  AuthenticatedGeneralPromotionsRouteRoute._addFileChildren(
    AuthenticatedGeneralPromotionsRouteRouteChildren,
  )

interface AuthenticatedGeneralBusinessCardsCardUuidRouteChildren {
  AuthenticatedGeneralBusinessCardsCardUuidEditRoute: typeof AuthenticatedGeneralBusinessCardsCardUuidEditRoute
}

const AuthenticatedGeneralBusinessCardsCardUuidRouteChildren: AuthenticatedGeneralBusinessCardsCardUuidRouteChildren =
  {
    AuthenticatedGeneralBusinessCardsCardUuidEditRoute:
      AuthenticatedGeneralBusinessCardsCardUuidEditRoute,
  }

const AuthenticatedGeneralBusinessCardsCardUuidRouteWithChildren =
  AuthenticatedGeneralBusinessCardsCardUuidRoute._addFileChildren(
    AuthenticatedGeneralBusinessCardsCardUuidRouteChildren,
  )

interface AuthenticatedGeneralGiftCardsGiftCardUuidRouteChildren {
  AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute: typeof AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute
}

const AuthenticatedGeneralGiftCardsGiftCardUuidRouteChildren: AuthenticatedGeneralGiftCardsGiftCardUuidRouteChildren =
  {
    AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute:
      AuthenticatedGeneralGiftCardsGiftCardUuidEditRoute,
  }

const AuthenticatedGeneralGiftCardsGiftCardUuidRouteWithChildren =
  AuthenticatedGeneralGiftCardsGiftCardUuidRoute._addFileChildren(
    AuthenticatedGeneralGiftCardsGiftCardUuidRouteChildren,
  )

interface AuthenticatedGeneralLoyaltyCardsCardUuidRouteChildren {
  AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute: typeof AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute
}

const AuthenticatedGeneralLoyaltyCardsCardUuidRouteChildren: AuthenticatedGeneralLoyaltyCardsCardUuidRouteChildren =
  {
    AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute:
      AuthenticatedGeneralLoyaltyCardsCardUuidEditRoute,
  }

const AuthenticatedGeneralLoyaltyCardsCardUuidRouteWithChildren =
  AuthenticatedGeneralLoyaltyCardsCardUuidRoute._addFileChildren(
    AuthenticatedGeneralLoyaltyCardsCardUuidRouteChildren,
  )

interface AuthenticatedGeneralRouteRouteChildren {
  AuthenticatedGeneralAnalyticsRouteRoute: typeof AuthenticatedGeneralAnalyticsRouteRouteWithChildren
  AuthenticatedGeneralCompaniesRouteRoute: typeof AuthenticatedGeneralCompaniesRouteRouteWithChildren
  AuthenticatedGeneralCustomersRouteRoute: typeof AuthenticatedGeneralCustomersRouteRouteWithChildren
  AuthenticatedGeneralInventoryRouteRoute: typeof AuthenticatedGeneralInventoryRouteRouteWithChildren
  AuthenticatedGeneralMarketingRouteRoute: typeof AuthenticatedGeneralMarketingRouteRouteWithChildren
  AuthenticatedGeneralOrdersRouteRoute: typeof AuthenticatedGeneralOrdersRouteRouteWithChildren
  AuthenticatedGeneralProductCategoriesRouteRoute: typeof AuthenticatedGeneralProductCategoriesRouteRouteWithChildren
  AuthenticatedGeneralProductGroupsRouteRoute: typeof AuthenticatedGeneralProductGroupsRouteRouteWithChildren
  AuthenticatedGeneralProductsRouteRoute: typeof AuthenticatedGeneralProductsRouteRouteWithChildren
  AuthenticatedGeneralPromotionsRouteRoute: typeof AuthenticatedGeneralPromotionsRouteRouteWithChildren
  AuthenticatedGeneralBusinessCardsCardUuidRoute: typeof AuthenticatedGeneralBusinessCardsCardUuidRouteWithChildren
  AuthenticatedGeneralGiftCardsGiftCardUuidRoute: typeof AuthenticatedGeneralGiftCardsGiftCardUuidRouteWithChildren
  AuthenticatedGeneralLoyaltyCardsCardUuidRoute: typeof AuthenticatedGeneralLoyaltyCardsCardUuidRouteWithChildren
  AuthenticatedGeneralBusinessCardsIndexRoute: typeof AuthenticatedGeneralBusinessCardsIndexRoute
  AuthenticatedGeneralGiftCardsIndexRoute: typeof AuthenticatedGeneralGiftCardsIndexRoute
  AuthenticatedGeneralLoyaltyCardsIndexRoute: typeof AuthenticatedGeneralLoyaltyCardsIndexRoute
}

const AuthenticatedGeneralRouteRouteChildren: AuthenticatedGeneralRouteRouteChildren =
  {
    AuthenticatedGeneralAnalyticsRouteRoute:
      AuthenticatedGeneralAnalyticsRouteRouteWithChildren,
    AuthenticatedGeneralCompaniesRouteRoute:
      AuthenticatedGeneralCompaniesRouteRouteWithChildren,
    AuthenticatedGeneralCustomersRouteRoute:
      AuthenticatedGeneralCustomersRouteRouteWithChildren,
    AuthenticatedGeneralInventoryRouteRoute:
      AuthenticatedGeneralInventoryRouteRouteWithChildren,
    AuthenticatedGeneralMarketingRouteRoute:
      AuthenticatedGeneralMarketingRouteRouteWithChildren,
    AuthenticatedGeneralOrdersRouteRoute:
      AuthenticatedGeneralOrdersRouteRouteWithChildren,
    AuthenticatedGeneralProductCategoriesRouteRoute:
      AuthenticatedGeneralProductCategoriesRouteRouteWithChildren,
    AuthenticatedGeneralProductGroupsRouteRoute:
      AuthenticatedGeneralProductGroupsRouteRouteWithChildren,
    AuthenticatedGeneralProductsRouteRoute:
      AuthenticatedGeneralProductsRouteRouteWithChildren,
    AuthenticatedGeneralPromotionsRouteRoute:
      AuthenticatedGeneralPromotionsRouteRouteWithChildren,
    AuthenticatedGeneralBusinessCardsCardUuidRoute:
      AuthenticatedGeneralBusinessCardsCardUuidRouteWithChildren,
    AuthenticatedGeneralGiftCardsGiftCardUuidRoute:
      AuthenticatedGeneralGiftCardsGiftCardUuidRouteWithChildren,
    AuthenticatedGeneralLoyaltyCardsCardUuidRoute:
      AuthenticatedGeneralLoyaltyCardsCardUuidRouteWithChildren,
    AuthenticatedGeneralBusinessCardsIndexRoute:
      AuthenticatedGeneralBusinessCardsIndexRoute,
    AuthenticatedGeneralGiftCardsIndexRoute:
      AuthenticatedGeneralGiftCardsIndexRoute,
    AuthenticatedGeneralLoyaltyCardsIndexRoute:
      AuthenticatedGeneralLoyaltyCardsIndexRoute,
  }

const AuthenticatedGeneralRouteRouteWithChildren =
  AuthenticatedGeneralRouteRoute._addFileChildren(
    AuthenticatedGeneralRouteRouteChildren,
  )

interface AuthenticatedSettingsExportsRouteRouteChildren {
  AuthenticatedSettingsExportsIndexRoute: typeof AuthenticatedSettingsExportsIndexRoute
}

const AuthenticatedSettingsExportsRouteRouteChildren: AuthenticatedSettingsExportsRouteRouteChildren =
  {
    AuthenticatedSettingsExportsIndexRoute:
      AuthenticatedSettingsExportsIndexRoute,
  }

const AuthenticatedSettingsExportsRouteRouteWithChildren =
  AuthenticatedSettingsExportsRouteRoute._addFileChildren(
    AuthenticatedSettingsExportsRouteRouteChildren,
  )

interface AuthenticatedSettingsIntegrationsRouteRouteChildren {
  AuthenticatedSettingsIntegrationsProviderRoute: typeof AuthenticatedSettingsIntegrationsProviderRoute
  AuthenticatedSettingsIntegrationsIndexRoute: typeof AuthenticatedSettingsIntegrationsIndexRoute
}

const AuthenticatedSettingsIntegrationsRouteRouteChildren: AuthenticatedSettingsIntegrationsRouteRouteChildren =
  {
    AuthenticatedSettingsIntegrationsProviderRoute:
      AuthenticatedSettingsIntegrationsProviderRoute,
    AuthenticatedSettingsIntegrationsIndexRoute:
      AuthenticatedSettingsIntegrationsIndexRoute,
  }

const AuthenticatedSettingsIntegrationsRouteRouteWithChildren =
  AuthenticatedSettingsIntegrationsRouteRoute._addFileChildren(
    AuthenticatedSettingsIntegrationsRouteRouteChildren,
  )

interface AuthenticatedSettingsInventoryRouteRouteChildren {
  AuthenticatedSettingsInventoryLocationsCreateRoute: typeof AuthenticatedSettingsInventoryLocationsCreateRoute
  AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute: typeof AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute
}

const AuthenticatedSettingsInventoryRouteRouteChildren: AuthenticatedSettingsInventoryRouteRouteChildren =
  {
    AuthenticatedSettingsInventoryLocationsCreateRoute:
      AuthenticatedSettingsInventoryLocationsCreateRoute,
    AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute:
      AuthenticatedSettingsInventoryLocationsInventoryLocationUuidEditRoute,
  }

const AuthenticatedSettingsInventoryRouteRouteWithChildren =
  AuthenticatedSettingsInventoryRouteRoute._addFileChildren(
    AuthenticatedSettingsInventoryRouteRouteChildren,
  )

interface AuthenticatedSettingsMarketingChannelsRouteRouteChildren {
  AuthenticatedSettingsMarketingChannelsIndexRoute: typeof AuthenticatedSettingsMarketingChannelsIndexRoute
}

const AuthenticatedSettingsMarketingChannelsRouteRouteChildren: AuthenticatedSettingsMarketingChannelsRouteRouteChildren =
  {
    AuthenticatedSettingsMarketingChannelsIndexRoute:
      AuthenticatedSettingsMarketingChannelsIndexRoute,
  }

const AuthenticatedSettingsMarketingChannelsRouteRouteWithChildren =
  AuthenticatedSettingsMarketingChannelsRouteRoute._addFileChildren(
    AuthenticatedSettingsMarketingChannelsRouteRouteChildren,
  )

interface AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteChildren {
  AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute: typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute
}

const AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteChildren: AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteChildren =
  {
    AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute:
      AuthenticatedSettingsPointOfSalePointOfSaleUuidEditRoute,
  }

const AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteWithChildren =
  AuthenticatedSettingsPointOfSalePointOfSaleUuidRoute._addFileChildren(
    AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteChildren,
  )

interface AuthenticatedSettingsPointOfSaleRouteRouteChildren {
  AuthenticatedSettingsPointOfSalePointOfSaleUuidRoute: typeof AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteWithChildren
  AuthenticatedSettingsPointOfSaleCreateRoute: typeof AuthenticatedSettingsPointOfSaleCreateRoute
}

const AuthenticatedSettingsPointOfSaleRouteRouteChildren: AuthenticatedSettingsPointOfSaleRouteRouteChildren =
  {
    AuthenticatedSettingsPointOfSalePointOfSaleUuidRoute:
      AuthenticatedSettingsPointOfSalePointOfSaleUuidRouteWithChildren,
    AuthenticatedSettingsPointOfSaleCreateRoute:
      AuthenticatedSettingsPointOfSaleCreateRoute,
  }

const AuthenticatedSettingsPointOfSaleRouteRouteWithChildren =
  AuthenticatedSettingsPointOfSaleRouteRoute._addFileChildren(
    AuthenticatedSettingsPointOfSaleRouteRouteChildren,
  )

interface AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteChildren {
  AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute
}

const AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteChildren: AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteChildren =
  {
    AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute:
      AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidEditUnlockPinRoute,
  }

const AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteWithChildren =
  AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRoute._addFileChildren(
    AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteChildren,
  )

interface AuthenticatedSettingsPointsOfSaleDevicesRouteRouteChildren {
  AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteWithChildren
  AuthenticatedSettingsPointsOfSaleDevicesIndexRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesIndexRoute
}

const AuthenticatedSettingsPointsOfSaleDevicesRouteRouteChildren: AuthenticatedSettingsPointsOfSaleDevicesRouteRouteChildren =
  {
    AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRoute:
      AuthenticatedSettingsPointsOfSaleDevicesPointOfSaleUuidRouteWithChildren,
    AuthenticatedSettingsPointsOfSaleDevicesIndexRoute:
      AuthenticatedSettingsPointsOfSaleDevicesIndexRoute,
  }

const AuthenticatedSettingsPointsOfSaleDevicesRouteRouteWithChildren =
  AuthenticatedSettingsPointsOfSaleDevicesRouteRoute._addFileChildren(
    AuthenticatedSettingsPointsOfSaleDevicesRouteRouteChildren,
  )

interface AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteChildren {
  AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute
}

const AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteChildren: AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteChildren =
  {
    AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute:
      AuthenticatedSettingsPointsOfSaleGroupsGroupUuidEditRoute,
  }

const AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteWithChildren =
  AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRoute._addFileChildren(
    AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteChildren,
  )

interface AuthenticatedSettingsPointsOfSaleGroupsRouteRouteChildren {
  AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteWithChildren
  AuthenticatedSettingsPointsOfSaleGroupsCreateRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsCreateRoute
}

const AuthenticatedSettingsPointsOfSaleGroupsRouteRouteChildren: AuthenticatedSettingsPointsOfSaleGroupsRouteRouteChildren =
  {
    AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRoute:
      AuthenticatedSettingsPointsOfSaleGroupsGroupUuidRouteWithChildren,
    AuthenticatedSettingsPointsOfSaleGroupsCreateRoute:
      AuthenticatedSettingsPointsOfSaleGroupsCreateRoute,
  }

const AuthenticatedSettingsPointsOfSaleGroupsRouteRouteWithChildren =
  AuthenticatedSettingsPointsOfSaleGroupsRouteRoute._addFileChildren(
    AuthenticatedSettingsPointsOfSaleGroupsRouteRouteChildren,
  )

interface AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteChildren {
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute
}

const AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteChildren: AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteChildren =
  {
    AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute:
      AuthenticatedSettingsPointsOfSalePointOfSaleUuidEditRoute,
    AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute:
      AuthenticatedSettingsPointsOfSalePointOfSaleUuidProductMenuRoute,
  }

const AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteWithChildren =
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute._addFileChildren(
    AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteChildren,
  )

interface AuthenticatedSettingsPointsOfSaleRouteRouteChildren {
  AuthenticatedSettingsPointsOfSaleDevicesRouteRoute: typeof AuthenticatedSettingsPointsOfSaleDevicesRouteRouteWithChildren
  AuthenticatedSettingsPointsOfSaleGroupsRouteRoute: typeof AuthenticatedSettingsPointsOfSaleGroupsRouteRouteWithChildren
  AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute: typeof AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteWithChildren
  AuthenticatedSettingsPointsOfSaleCreateRoute: typeof AuthenticatedSettingsPointsOfSaleCreateRoute
}

const AuthenticatedSettingsPointsOfSaleRouteRouteChildren: AuthenticatedSettingsPointsOfSaleRouteRouteChildren =
  {
    AuthenticatedSettingsPointsOfSaleDevicesRouteRoute:
      AuthenticatedSettingsPointsOfSaleDevicesRouteRouteWithChildren,
    AuthenticatedSettingsPointsOfSaleGroupsRouteRoute:
      AuthenticatedSettingsPointsOfSaleGroupsRouteRouteWithChildren,
    AuthenticatedSettingsPointsOfSalePointOfSaleUuidRoute:
      AuthenticatedSettingsPointsOfSalePointOfSaleUuidRouteWithChildren,
    AuthenticatedSettingsPointsOfSaleCreateRoute:
      AuthenticatedSettingsPointsOfSaleCreateRoute,
  }

const AuthenticatedSettingsPointsOfSaleRouteRouteWithChildren =
  AuthenticatedSettingsPointsOfSaleRouteRoute._addFileChildren(
    AuthenticatedSettingsPointsOfSaleRouteRouteChildren,
  )

interface AuthenticatedSettingsProfileRouteRouteChildren {
  AuthenticatedSettingsProfileEditRoute: typeof AuthenticatedSettingsProfileEditRoute
  AuthenticatedSettingsProfileIndexRoute: typeof AuthenticatedSettingsProfileIndexRoute
}

const AuthenticatedSettingsProfileRouteRouteChildren: AuthenticatedSettingsProfileRouteRouteChildren =
  {
    AuthenticatedSettingsProfileEditRoute:
      AuthenticatedSettingsProfileEditRoute,
    AuthenticatedSettingsProfileIndexRoute:
      AuthenticatedSettingsProfileIndexRoute,
  }

const AuthenticatedSettingsProfileRouteRouteWithChildren =
  AuthenticatedSettingsProfileRouteRoute._addFileChildren(
    AuthenticatedSettingsProfileRouteRouteChildren,
  )

interface AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteChildren {
  AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute: typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute
}

const AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteChildren: AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteChildren =
  {
    AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute:
      AuthenticatedSettingsSalesChannelsGroupsGroupUuidEditRoute,
  }

const AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteWithChildren =
  AuthenticatedSettingsSalesChannelsGroupsGroupUuidRoute._addFileChildren(
    AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteChildren,
  )

interface AuthenticatedSettingsSalesChannelsGroupsRouteRouteChildren {
  AuthenticatedSettingsSalesChannelsGroupsGroupUuidRoute: typeof AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteWithChildren
  AuthenticatedSettingsSalesChannelsGroupsCreateRoute: typeof AuthenticatedSettingsSalesChannelsGroupsCreateRoute
}

const AuthenticatedSettingsSalesChannelsGroupsRouteRouteChildren: AuthenticatedSettingsSalesChannelsGroupsRouteRouteChildren =
  {
    AuthenticatedSettingsSalesChannelsGroupsGroupUuidRoute:
      AuthenticatedSettingsSalesChannelsGroupsGroupUuidRouteWithChildren,
    AuthenticatedSettingsSalesChannelsGroupsCreateRoute:
      AuthenticatedSettingsSalesChannelsGroupsCreateRoute,
  }

const AuthenticatedSettingsSalesChannelsGroupsRouteRouteWithChildren =
  AuthenticatedSettingsSalesChannelsGroupsRouteRoute._addFileChildren(
    AuthenticatedSettingsSalesChannelsGroupsRouteRouteChildren,
  )

interface AuthenticatedSettingsSalesChannelsTypesRouteRouteChildren {
  AuthenticatedSettingsSalesChannelsTypesCreateRoute: typeof AuthenticatedSettingsSalesChannelsTypesCreateRoute
}

const AuthenticatedSettingsSalesChannelsTypesRouteRouteChildren: AuthenticatedSettingsSalesChannelsTypesRouteRouteChildren =
  {
    AuthenticatedSettingsSalesChannelsTypesCreateRoute:
      AuthenticatedSettingsSalesChannelsTypesCreateRoute,
  }

const AuthenticatedSettingsSalesChannelsTypesRouteRouteWithChildren =
  AuthenticatedSettingsSalesChannelsTypesRouteRoute._addFileChildren(
    AuthenticatedSettingsSalesChannelsTypesRouteRouteChildren,
  )

interface AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteChildren {
  AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute: typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute
}

const AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteChildren: AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteChildren =
  {
    AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute:
      AuthenticatedSettingsSalesChannelsSalesChannelUuidEditRoute,
  }

const AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteWithChildren =
  AuthenticatedSettingsSalesChannelsSalesChannelUuidRoute._addFileChildren(
    AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteChildren,
  )

interface AuthenticatedSettingsSalesChannelsRouteRouteChildren {
  AuthenticatedSettingsSalesChannelsGroupsRouteRoute: typeof AuthenticatedSettingsSalesChannelsGroupsRouteRouteWithChildren
  AuthenticatedSettingsSalesChannelsTypesRouteRoute: typeof AuthenticatedSettingsSalesChannelsTypesRouteRouteWithChildren
  AuthenticatedSettingsSalesChannelsSalesChannelUuidRoute: typeof AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteWithChildren
  AuthenticatedSettingsSalesChannelsCreateRoute: typeof AuthenticatedSettingsSalesChannelsCreateRoute
}

const AuthenticatedSettingsSalesChannelsRouteRouteChildren: AuthenticatedSettingsSalesChannelsRouteRouteChildren =
  {
    AuthenticatedSettingsSalesChannelsGroupsRouteRoute:
      AuthenticatedSettingsSalesChannelsGroupsRouteRouteWithChildren,
    AuthenticatedSettingsSalesChannelsTypesRouteRoute:
      AuthenticatedSettingsSalesChannelsTypesRouteRouteWithChildren,
    AuthenticatedSettingsSalesChannelsSalesChannelUuidRoute:
      AuthenticatedSettingsSalesChannelsSalesChannelUuidRouteWithChildren,
    AuthenticatedSettingsSalesChannelsCreateRoute:
      AuthenticatedSettingsSalesChannelsCreateRoute,
  }

const AuthenticatedSettingsSalesChannelsRouteRouteWithChildren =
  AuthenticatedSettingsSalesChannelsRouteRoute._addFileChildren(
    AuthenticatedSettingsSalesChannelsRouteRouteChildren,
  )

interface AuthenticatedSettingsUsersUserUuidRouteChildren {
  AuthenticatedSettingsUsersUserUuidEditRoute: typeof AuthenticatedSettingsUsersUserUuidEditRoute
  AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute: typeof AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute
}

const AuthenticatedSettingsUsersUserUuidRouteChildren: AuthenticatedSettingsUsersUserUuidRouteChildren =
  {
    AuthenticatedSettingsUsersUserUuidEditRoute:
      AuthenticatedSettingsUsersUserUuidEditRoute,
    AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute:
      AuthenticatedSettingsUsersUserUuidEditSignInCredentialsRoute,
  }

const AuthenticatedSettingsUsersUserUuidRouteWithChildren =
  AuthenticatedSettingsUsersUserUuidRoute._addFileChildren(
    AuthenticatedSettingsUsersUserUuidRouteChildren,
  )

interface AuthenticatedSettingsUsersRouteRouteChildren {
  AuthenticatedSettingsUsersUserUuidRoute: typeof AuthenticatedSettingsUsersUserUuidRouteWithChildren
  AuthenticatedSettingsUsersInviteRoute: typeof AuthenticatedSettingsUsersInviteRoute
}

const AuthenticatedSettingsUsersRouteRouteChildren: AuthenticatedSettingsUsersRouteRouteChildren =
  {
    AuthenticatedSettingsUsersUserUuidRoute:
      AuthenticatedSettingsUsersUserUuidRouteWithChildren,
    AuthenticatedSettingsUsersInviteRoute:
      AuthenticatedSettingsUsersInviteRoute,
  }

const AuthenticatedSettingsUsersRouteRouteWithChildren =
  AuthenticatedSettingsUsersRouteRoute._addFileChildren(
    AuthenticatedSettingsUsersRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsExportsRouteRoute: typeof AuthenticatedSettingsExportsRouteRouteWithChildren
  AuthenticatedSettingsIntegrationsRouteRoute: typeof AuthenticatedSettingsIntegrationsRouteRouteWithChildren
  AuthenticatedSettingsInventoryRouteRoute: typeof AuthenticatedSettingsInventoryRouteRouteWithChildren
  AuthenticatedSettingsMarketingChannelsRouteRoute: typeof AuthenticatedSettingsMarketingChannelsRouteRouteWithChildren
  AuthenticatedSettingsPointOfSaleRouteRoute: typeof AuthenticatedSettingsPointOfSaleRouteRouteWithChildren
  AuthenticatedSettingsPointsOfSaleRouteRoute: typeof AuthenticatedSettingsPointsOfSaleRouteRouteWithChildren
  AuthenticatedSettingsProfileRouteRoute: typeof AuthenticatedSettingsProfileRouteRouteWithChildren
  AuthenticatedSettingsSalesChannelsRouteRoute: typeof AuthenticatedSettingsSalesChannelsRouteRouteWithChildren
  AuthenticatedSettingsUsersRouteRoute: typeof AuthenticatedSettingsUsersRouteRouteWithChildren
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsAccessKeysIndexRoute: typeof AuthenticatedSettingsAccessKeysIndexRoute
  AuthenticatedSettingsBillingIndexRoute: typeof AuthenticatedSettingsBillingIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsExportsRouteRoute:
      AuthenticatedSettingsExportsRouteRouteWithChildren,
    AuthenticatedSettingsIntegrationsRouteRoute:
      AuthenticatedSettingsIntegrationsRouteRouteWithChildren,
    AuthenticatedSettingsInventoryRouteRoute:
      AuthenticatedSettingsInventoryRouteRouteWithChildren,
    AuthenticatedSettingsMarketingChannelsRouteRoute:
      AuthenticatedSettingsMarketingChannelsRouteRouteWithChildren,
    AuthenticatedSettingsPointOfSaleRouteRoute:
      AuthenticatedSettingsPointOfSaleRouteRouteWithChildren,
    AuthenticatedSettingsPointsOfSaleRouteRoute:
      AuthenticatedSettingsPointsOfSaleRouteRouteWithChildren,
    AuthenticatedSettingsProfileRouteRoute:
      AuthenticatedSettingsProfileRouteRouteWithChildren,
    AuthenticatedSettingsSalesChannelsRouteRoute:
      AuthenticatedSettingsSalesChannelsRouteRouteWithChildren,
    AuthenticatedSettingsUsersRouteRoute:
      AuthenticatedSettingsUsersRouteRouteWithChildren,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
    AuthenticatedSettingsAccessKeysIndexRoute:
      AuthenticatedSettingsAccessKeysIndexRoute,
    AuthenticatedSettingsBillingIndexRoute:
      AuthenticatedSettingsBillingIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedGeneralRouteRoute: typeof AuthenticatedGeneralRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedGeneralRouteRoute: AuthenticatedGeneralRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
